export default {
    id: "IDENTIFIANT",
    dashboard: "Tableau de bord",
    warning: "Avertissement",
    users: "Utilisateurs",
    farms: "Fermes",
    animals: "Animaux",
    action: "Action",
    actionList: "Liste d'action",
    drugInventory: "Inventaire des médicaments",
    inseminatorStatistics: "Statistiques des inséminateurs",
    organizationNTR: "Organisation NTR",
    genotypePerformance: "Performances génotypiques",
    semenAutomation: "Automatisation du sperme",
    activityLogs: "Journal d'activité",
    username: "Nom d'utilisateur",
    title: "Titre",
    deactivated: "Désactivé",
    name: "Nom",
    email: "E-mail",
    emailAddress: "Adresse e-mail",
    mobileNum: "Numéro de portable",
    emailOrMobile: "E-mail/portable",
    role: "Rôle",
    roles: "Les rôles",
    department: "Département",
    status: "Statut",
    pages: "pages",
    departments: "Départements",
    password: "Mot de passe",
    cancel: "Annuler",
    submit: "Soumettre",
    error: "erreur",
    success: "succès",
    Browse: "Parcourir",
    orDropYourFileCsvXlsXlsxHere: "ou déposez votre fichier (CSV, XLS, XLSx) ici",
    search: "Recherche",
    apply: "Appliquer",
    select: "Sélectionner",
    previous: "Précédent",
    mandatory: "Obligatoire",
    dropYourFileHere: "ou déposez votre fichier (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) ici",
    restoreDefault: "Restaurer par défaut",
    pending: "En attente",
    completed: "Complété",
    remove: "Retirer",
    update: "Mise à jour",
    removeFile: "Effacer le fichier",
    uploadFile: "Téléverser un fichier",
    pleaseChoosePreferedLanguage: "Veuillez choisir votre langue préférée",
    edit: "Modifier",
    activate: "Activer",
    deactivate: "Désactiver",
    recievedOrders: "Commandes reçues",
    chartRepresentation: "Représentation graphique",
    nameIsRequired: "Le nom est requis",
    export: "Exporter",
    noFilesAvailable: "AUCUN FICHIER DISPONIBLE",
    selectDepartmentToshowRoles: "Sélectionnez un service pour afficher les rôles",
    selectDepartmentWithActiveRoles: "Sélectionnez un département avec des rôles actifs",
    nameCanContainOnlyAlphabets: "Le nom ne peut contenir que des alphabetes",
    nameMustBeLessThan15Chars: "Le nom doit comporter moins de 30 caractères",
    emailRequired: "L'e-mail est requis",
    invalidEmailFormat: "Format d'email invalide",
    mobNumReq: "Le numéro de portable est requis",
    invalidMobFormat: "Format de numéro de mobile invalide.",
    passwordRequired: "Mot de passe requis",
    departmentReq: "Le département est requis",
    roleReq: "Le rôle est requis",
    unableToUpdate: "Impossible de mettre à jour",
    orignalName: "Nom d'origine",
    uploadedDate: "Date de téléchargement",
    fileName: "Nom de fichier",
    importNum: "Numéro d'importation",
    languagePreferences: "Préférence de langue",
    pleaseTryAgainAfterSometime: "Veuillez essayer après un certain temps",
    noChanges: "Aucun changement",
    nothingchanged: "Rien n'a changé",
    pleaseChooseAnImageFile: "Veuillez choisir un fichier image",
    fileIsTooBigSelectUnder1MB: "Votre fichier est trop volumineux ! ",
    phoneShouldHave10Chars: "Le téléphone doit comporter 10 caractères",
    onlyCSVAllowed: "Seul le fichier CSV est autorisé",
    loadingPleaseWait: "Chargement, veuillez patienter",
    manager: "directeur",
    administrator: "administrateur",
    Comingsoon: "À venir",
    totalAnimals: "Animaux totaux",
    receivedOrders: "Commandes reçues",
    drugs: "Drogues",
    detailedAnalysis: "Analyse détaillée",
    barGraphRepOfActiveUsersAndDeactivateUsers: "Représentation sous forme de graphique à barres des utilisateurs actifs et des utilisateurs désactivés",
    barGraphRepOfRegAnimalsVsFarm: "Représentation graphique à barres des animaux enregistrés par rapport à la ferme",
    roleNumber: "Numéro de rôle",
    roleName: "Nom de rôle",
    active: "Actif",
    inactive: "Inactif",
    admin: "Administrateur",
    addRole: "Ajouter un rôle",
    addRoles: "Ajouter des rôles",
    permissions: "Autorisations",
    sr: "Sr.",
    moduleName: "Nom du module",
    view: "Voir",
    deptNo: "Numéro de département",
    selectByCategory: "Sélectionnez Par catégorie",
    weeklyAnalytics: "Analyse hebdomadaire",
    pregnancy: "Grossesse",
    analytics: "Analytique",
    calendar: "Calendrier",
    productName: "Nom du produit",
    volumeSold: "Volume vendu",
    recordPoints: "Points d'enregistrement",
    inStock: "En stock",
    revenue: "Revenu",
    stockStatus: "État des stocks",
    barChart: "Diagramme à bandes",
    lineChart: "Graphique en ligne",
    indexReturns: "Rendements de l'indice",
    chart: "Graphique",
    time: "temps",
    production: "Production",
    customization: "Personnalisation",
    recordsPerPage: "Enregistrements par page",
    noDataAvailable: "Pas de données disponibles",
    reporting: "Rapports",
    optional: "Facultatif",
    note: "Note",
    notes: "Remarques",
    date: "Date",
    kG: "KG",
    weight: "lester",
    type: "Taper",
    lessthan3Month: "<3 mois",
    lessthan6Month: "<6 mois",
    lessthan7Month: "<7 mois",
    lastWeek: "La semaine dernière",
    thisWeek: "Cette semaine",
    lessthanOneYear: "<1 ans",
    lessthanTwoYear: "<2 ans",
    lessthanThreeYear: "<3 ans",
    lessthanFourYear: "<4 ans",
    yes: "Oui",
    no: "Non",
    of: "de",
    notSpecified: "Non spécifié",
    days: "jours",
    day: "jour",
    aDay: "un jour",
    years: "années",
    year: "année",
    unit: "unité",
    units: "Unités",
    to: "pour",
    profile: "Profil",
    logOut: "Se déconnecter",
    Unit: "Unité",
    otherSettings: "Autres réglages",
    somethingWentWrong: "quelque chose s'est mal passé.",
    toDo: "Faire",
    loadingData: "Chargement des données...",
    taskNumber: "Numéro de tâche",
    taskName: "Nom de la tâche",
    startDate: "Date de début",
    dueDate: "Date d'échéance",
    reason: "Raison",
    quantity: "Quantité",
    cost: "Coût",
    noRecordFound: "Aucun Enregistrement Trouvé",
    dailyUpdates: "Mises à jour quotidiennes",
    weeklyUpdates: "Mises à jour hebdomadaires",
    moduleAccessed: "Accès au module",
    typesOfAccess: "Types d'accès",
    userId: "ID de l'utilisateur",
    lastLogin: "Dernière connexion",
    terminalID: "Identifiant du terminal",
    geographicalAccessPoint: "Point d'accès géographique",
    iPAddress: "Adresse IP",
    fileAccessed: "Fichier consulté",
    functionAccessed: "Fonction accédée",
    webPageURL: "URL de la page Web",
    accessType: "Type d'accès",
    unsuccessfulLoginAttempts: "Tentatives de connexion infructueuses",
    customerAddress: "Adresse du client",
    orderdate: "Date de commande",
    postageDate: "Date d'affranchissement",
    postID: "ID de publication",
    packingTechnician: "Technicien d'emballage",
    packingTechnicia: "Technique d'emballage",
    packEdit: "Paquet Modifier",
    batchNumber: "Numéro de lot",
    collectionTechnician: "Technicien de recouvrement",
    collectionTechnicia: "Technique de collecte",
    preparationTechnicia: "Technique de préparation",
    preparationTechnician: "Technicien de préparation",
    approvedManually: "Approuvé manuellement",
    researcher: "Chercheur",
    dateOfApproval: "Date d'approbation",
    approvalEdit: "Approbation Modifier",
    searchByAllExceptDate: "Rechercher par tous sauf la date",
    approval: "Approbation",
    collection: "Collection",
    postage: "Affranchissement",
    pack: "Paquet",
    straws: "Pailles",
    createdAt: "Créé à",
    sireID: "ID du père",
    economicIndexValue: "Valeur de l'indice économique",
    latestCollectionDate: "Dernière date de collecte",
    locationId: "Identifiant de l'emplacement",
    lastUpdated: "Dernière mise à jour",
    print: "Imprimer",
    save: "Sauvegarder",
    tax: "Impôt",
    phoneNo: "Pas de téléphone",
    exportAsPDF: "Exporter au format PDF",
    statusUpdated: "Statut mis à jour",
    statusNotUpdated: "Statut non mis à jour",
    inProgress: "En cours",
    assignedTo: "Assigné à",
    taskId: "ID de tâche",
    createdDate: "Date de création",
    numberOfAnimals: "Nombre d'animaux",
    healthRecordSubmittedSuccess: "Dossier de santé soumis avec succès",
    healthRecordSubmitted: "Dossier de santé soumis.",
    InseminationRecordSubmittedSuccesful: "Dossier d'insémination soumis avec succès",
    inseminationRecordSubmitted: "Dossier d'insémination soumis.",
    actionListDailyTask: "Liste d'actions - Tâche quotidienne",
    sinceLastYear: "Depuis l'année dernière",
    sinceLastQuarter: "Depuis le dernier trimestre",
    sinceLastMonth: "Depuis le mois dernier",
    sinceLastWeek: "Depuis la semaine dernière",
    drugWithdrawPeriod: "Période de retrait du médicament",
    diagnosisName: "Nom du diagnostic",
    animalWithNoGenetype: "Cet animal n'a aucune donnée de génotype enregistrée. ",
    nameOfPreviousOwner: "Nom du propriétaire précédent",
    avatarSize: "La taille de l'avatar doit être inférieure à 1 Mo !",
    testDestination: "Destination d'essai",
    animalNotAdded: "Animal non ajouté",
    registerationSuccessful: "Inscription réussi",
    backToAnimalList: "Retour à la liste des animaux",
    addAnotherAnimal: "Ajouter un autre animal",
    animalDetailsUpdated: "Détails de l'animal mis à jour avec succès",
    animalUpdatedSuccessfully: "Animal mis à jour avec succès",
    animalNotUpdated: "Animal non mis à jour",
    notMember: "Pas un membre?",
    requestAccess: "Demande d'accès",
    typePassword: "Veuillez saisir le mot de passe.",
    minChars: "minimum 6 caractères",
    typeConfirmPassword: "tapez confirmer le mot de passe",
    passConfig: "La confirmation du mot de passe ne correspond pas.",
    invalidEmailMobile: "Format e-mail/mobile invalide",
    passwordNotEmpty: "Le mot de passe ne peut pas être vide",
    passwordLength: "La longueur du mot de passe ne peut pas être inférieure à 8 caractères",
    cityVillage: "Village de la ville",
    districtRegion: "Arrondissement / Région",
    alreadyHaveAnAccount: "Vous avez déjà un compte ?",
    genetypeUpdated: "Génotype mis à jour",
    genetypeNotUpdated: "Génotype non mis à jour",
    sellTrade: "Vendre/Échanger",
    milkingDevon: "Stock de reproduction du Devon laitier à vendre",
    detailedDescription: "Description détaillée",
    longPara: "American Milk Devon Bulls génisses et vaches. ",
    contactSeller: "Contacter le vendeur",
    enterListingTitle: "Entrez le titre de l'annonce",
    livestocktype: "Type de bétail",
    uploadImage: "Télécharger une image",
    mobilePhone: "Numéro de téléphone portable",
    myLivestock: "Mon bétail",
    livestockObservations: "Observations du bétail",
    selectFromRegisteredAnimals: "Sélectionnez dans la liste des animaux enregistrés",
    selectOption: "Sélectionner une option",
    selectTypeObservation: "Sélectionnez le type d'observation",
    attachVeteinaryDocument: "Joindre un document vétérinaire",
    addsensorReading: "Ajouter une lecture de capteur",
    myDocument: "Mes documents",
    enterAKeyword: "Entrez un mot-clé",
    documentType: "Type de document",
    registerEditLivestock: "Enregistrer/modifier le bétail",
    editLivestockProfile: "Modifier le profil du bétail",
    copy: "Copie",
    dateOfRegister: "Date d'enregistrement",
    livestockType: "Type de bétail",
    registerNewLivestock: "Enregistrer le nouveau bétail",
    enterUniqueTag: "Saisir une balise unique",
    color: "Couleur",
    gender: "Genre",
    male: "Homme",
    female: "Femme",
    damm: "Barrage",
    siree: "Sire",
    dateOfSaleAuction: "Date de vente/vente aux enchères",
    auctionRecord: "Record d'enchères de Deathlist",
    distinguishingFeatures: "Caractéristiques distinctives",
    keywordListing: "Mot-clé ou ID de fiche",
    adType: "Type d'annonce",
    activeListingFund: "1 annonce active trouvée",
    setupSensors: "Configurer les capteurs",
    serialNumber: "Numéro de série",
    sensorLocation: "Emplacement du capteur",
    sensorType: "Type de capteur",
    installationDate: "Date d'installation",
    ExpirationDate: "Date d'expiration",
    addGeo: "Ajouter la géolocalisation",
    addMoreSensors: "Ajouter plus de capteurs",
    trackAndTrace: "Suivre et tracer",
    createNewShipment: "Créer un nouvel envoi",
    workflowReference: "Référence du flux de travail",
    invoiceDate: "Date de facturation",
    trackShipment: "Suivi de livraison",
    totalShipments: "Total des expéditions",
    activeShipment: "Expéditions actives",
    completedObjectives: "Objectifs complétés",
    processedPayments: "Paiements traités",
    pointOfDestination: "Lieu de destination",
    sellerInformation: "Information du vendeur",
    selectSellerConsignor: "Sélectionnez le vendeur/expéditeur",
    pointOfOrigin: "Point d'origine",
    buyerInfo: "Informations sur l'acheteur",
    selectBuyerConsignor: "Sélectionnez l'acheteur/l'expéditeur",
    addSensorTriggers: "Ajouter des déclencheurs de capteur",
    processPayments: "Traiter les paiements",
    defineShippingContract: "Définir le contrat d'expédition",
    addDigitize: "Ajouter",
    currentlyOnFarm: "Actuellement à la ferme",
    addSire: "Ajouter un père",
    addApproval: "Ajouter une approbation",
    addCollection: "Ajouter une collection",
    addStraws: "Ajouter des pailles",
    addPack: "Ajouter un pack",
    addPostage: "Ajouter des frais de port",
    searchBySire: "Rechercher par père",
    anyDataChangeMightBeLost: "Toute modification de données peut être perdue",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "Souhaitez-vous enregistrer ou souhaitez-vous quitter sans enregistrer",
    leave: "Partir",
    stay: "Rester",
    animalFarm: "Animal de ferme",
    animalFarmH: "Animal de ferme",
    animalOrigin: "Origine animale",
    animalOriginH: "Origine animale",
    farmOfOrigin: "Ferme d'origine",
    farmOfOriginH: "Ferme d'origine",
    selectFarm: "Sélectionnez la ferme",
    searchFarm: "Rechercher une ferme",
    confirmation: "Confirmation",
    proceed: "Procéder",
    ok: "D'ACCORD",
    animal: {
      tagH: "Étiqueter",
      tagNumberH: "Numéro d'étiquette : Vous pouvez ajouter de la couleur ainsi que du numéro. ",
      goveRegNoH: "Les détails d'identification qui peuvent inclure le nom et l'adresse de la personne, l'agent de la personne pour la signification du processus, le lieu de l'activité à exécuter et une description du service fourni par la personne.",
      birthWeightH: "Poids à la naissance du veau",
      birthEaseH: "La naissance chez le bétail est un processus naturel, mais il peut parfois y avoir des problèmes de naissance où le barrage a besoin de l'aide de l'agriculteur/pasteur.",
      birthFarmH: "Ferme d'origine animale/naissance.",
      surrogateDamH: "L'ID de la vache femelle dans laquelle l'ovule fécondé d'un mâle donneur et d'une femelle donneuse est implanté pour son développement ultérieur.",
      ownerH: "C'est le nom du propriétaire de l'animal.",
      damH: "L'ID du parent femelle/mère de l'animal.",
      sireH: "L'ID du parent mâle/père de l'animal.",
      breedH: "Une race est un groupe spécifique d'animaux domestiques ayant une apparence homogène (phénotype), un comportement homogène et/ou d'autres caractéristiques qui la distinguent des autres organismes de la même espèce.",
      conceptionMethodH: "Comment l'animal a été conçu.",
      genderH: "Sexe de l'animal.",
      dobH: "Date de naissance de l'animal.",
      operatorH: "Le nom de la personne qui remplit les informations de cet animal.",
      removalFarmH: "Animal retiré de la ferme ",
      dateOfRemovalH: "Date de retrait de l'animal",
      destinationOfRemoval: "Lieu de destination de l'animal retiré",
      reasonOfRemovalH: "Raison du retrait de l'animal",
      trackingNumberH: "Numéro attribué à l'animal lors du retrait de l'animal",
      brandH: "Marque-simplement une marque permanente qui a été gravée sur la vache.",
      tattoH: "Tatouage sur animal.",
      hornStatusH: "Si l'animal est écorné.",
      animalOriginH: "Le pays d'origine de l'animal.",
      previousOwnerH: "Nom de l'ancien propriétaire de l'animal s'il s'agit d'un animal adulte.",
      twinH: "Ce champ indique si l'animal a un jumeau ou non.",
      regBreedAssoNoH: "Inscription auprès des associations/sociétés de race.",
      breedAssoNameH: "Nom des associations/sociétés où l'animal a été enregistré",
      breederH: "C'est le nom de l'organisation qui a fourni l'animal.",
      breeder: "Éleveur",
      noteH: "Remarque(s) importante(s) sur l'animal.",
      accuracyWeight_for_field: "Précision Poids",
      conception: "Conception",
      addAnAnimal: "Ajouter un animal",
      addAnimal: "Ajouter un animal",
      registerAnAnimal: "Enregistrer un animal",
      uploadAnAnimal: "Télécharger un animal",
      animalRegistration: "Enregistrement des animaux",
      animalDetails: "Détails des animaux",
      tag: "Étiqueter",
      tagNumber: "Numéro d'étiquette",
      govtRegNumber: "Gouv. ",
      birthWeight: "Poids à la naissance",
      birthEase: "Facilité de naissance",
      birthFarm: "Ferme de naissance",
      surrogateDam: "Barrage de substitution",
      owner: "Propriétaire",
      ownershipType: "Type de propriété",
      animalDiseaseRecord: "AnimalMaladieRecord",
      govtReg: "Gouv. ",
      regDate: "Date d'inscription",
      dam: "Barrage",
      sire: "Sire",
      heifer: "Génisse",
      steer: "Diriger",
      calf: "Veau",
      farmHerd: "Ferme/troupeau",
      femaleCalf: "Veau femelle",
      maleCalf: "Veau mâle",
      newCalves: "Nouveaux veaux",
      breed: "Race",
      conceptionMethod: "Méthode de conception",
      gender: "Genre",
      dateOfBirth: "Date de naissance",
      operator: "Opérateur",
      animalRemovedFarm: "Animal retiré de la ferme",
      dateOfAnimalRemoval: "Date de retrait de l'animal",
      destinationOfRemovedAnimal: "Destination de l'animal retiré",
      reasonOfRemoval: "Raison du retrait",
      optionalAnimalInformation: "Informations facultatives sur les animaux",
      animalPicture: "Photo d'animaux",
      trackingNumber: "Numéro de suivi",
      brand: "Marque",
      tatto: "Tatouage",
      hornStatus: "État du klaxon",
      animalOrigin: "Origine animale",
      previosOwner: "Propriétaire précédent",
      twin: "Double",
      InABreedAssociation: "Rég.",
      nameOfBreedAssociations: "Nom des associations de race",
      breedAssociations: "Associations de race",
      breederSupplier: "Éleveur (fournisseur)",
      importAnimal: "Importer des animaux",
      loadingAnimals: "Chargement des animaux... Veuillez patienter",
      totalRegAnimals: "Total rég. ",
      totalPregnantAnimals: "Nombre total d'animaux gestants",
      pregnantAnimalHistory: "Histoire de l'animal gravide",
      dailyAnimalPregnancyUpdates: "Mises à jour quotidiennes sur la grossesse animale",
      animalHistory: "Histoire animale",
      dailyAnimalUpdates: "Mises à jour quotidiennes sur les animaux",
      totalPregnant: "Enceinte totale",
      totalNewBorn: "Total des nouveau-nés",
      searchByIDGOVRegTag: "Recherche par ID, enregistrement GOV et étiquette",
      noANIMALAVAILABLE: "AUCUN ANIMAL DISPONIBLE",
      associationNumber: "Numéro d'association",
      associationName: "Nom de l'association",
      destinationName: "Nom du destinataire",
      plastic: "Plastique",
      metal: "Métal",
      naturalMating: "Accouplement naturel",
      artificialInsemination: "Insémination artificielle",
      embryoTransfer: "Transfert d'embryon",
      noAssistance: "Aucune aide",
      someAssistance: "Un peu d'aide",
      mechanicalAssistance: "Assistance mécanique",
      aCesareanSection: "Une césarienne",
      abnormalDelivery: "Livraison anormale",
      male: "Homme",
      female: "Femme",
      sale: "Vente",
      slaughter: "Abattage",
      death: "Décès",
      theft: "Vol",
      other: "Autre",
      horned: "Cornu",
      polled: "Interrogé",
      dehorned: "Décorné",
      details: "Détails",
      performance: "Performance",
      geneticWorth: "Valeur génétique",
      healthRecord: "Carnet de santé",
      genotypeData: "Données de génotype",
      reminders: "Rappels",
      activityLog: "Journal d'activité",
      activityLogDetails: "Détails du journal d'activité",
      editAnimal: "Modifier l'animal",
      familyInfo: "Informations sur la famille",
      breedInfo: "Informations sur la race",
      identification: "Identification",
      removalInfo: "Informations sur la suppression",
      iDOfAnimalDam: "ID de la mère de l'animal.",
      iDOfAnimalSire: "ID du père de l'animal.",
      iDOfDamEmbryoUsed: "ID de la mère dont l'embryon a été utilisé.",
      animalHasATwinOrNot: "Que l'animal ait un jumeau ou non.",
      breedType: "Type de race",
      breedOfTheAnimal: "C'est une race de l'animal.",
      regBreedAssociations: "Inscription auprès des associations/sociétés de race.",
      nameOfAssociationsSocieties: "Nom des associations/sociétés où l'animal a été enregistré.",
      nameOfTheOrgSuppliedAnimal: "C'est le nom de l'organisation qui a fourni l'animal.",
      countryOriginAnimal: "Le pays d'origine de l'animal.",
      birthFarmID: "ID de la ferme de naissance",
      farmIDAnimalBorn: "L'identifiant de la ferme où l'animal est né.",
      currentOwner: "Propriétaire actuel",
      nameOfOwnerAnimal: "C'est le nom du propriétaire de l'animal.",
      registrationDate: "Date d'inscription",
      previousOwner: "Propriétaire précédent",
      nameOfOperator: "Nom de l'opérateur",
      dateAnimalRemoved: "Date à laquelle l'animal est retiré.",
      destinationPlaceRemovedAnimal: "Lieu de destination de l'animal retiré",
      namePersonFillAnimalInformation: "Le nom de la personne qui remplit les informations de cet animal.",
      reasonOfAnimalRemoval: "Raison du retrait de l'animal",
      reasonWhyTheAnimalIsRemoved: "Raison pour laquelle l'animal est retiré",
      processingDate: "Date de traitement",
      DateInformationFilledChanged: "La date à laquelle les informations actuelles ont été renseignées ou modifiées.",
      animalID: "Identification des animaux",
      UniqueIdAnimal: "C'est l'identifiant unique de l'animal.",
      plasticTagNumber: "Numéro d'étiquette en plastique",
      numberAnimalTag: "Numéro de l'étiquette de l'animal.",
      rFTagNumber: "Numéro d'étiquette RF",
      numberAnimalRFTag: "Numéro de l'étiquette RF de l'animal.",
      govtRegNumb: "Gouv. ",
      govtRegistrationNumber: "Les détails d'identification qui peuvent inclure le nom et l'adresse de la personne, l'agent de la personne pour la signification du processus, le lieu de l'activité à exécuter et une description du service fourni par la personne.",
      numberAssignedAnimalIsRemoved: "Le numéro de suivi est l'un des identifiants des animaux utilisés pour suivre l'activité des animaux.",
      dateOfAnimalRegistration: "Date d'enregistrement de l'animal",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "Marque-simplement une marque permanente qui a été gravée sur la vache.",
      tattoOnAnimal: "Tatouage sur animal.",
      whetherTheAnimalIsDehorned: "Si l'animal est écorné.",
      milkingAnimals: "Animaux à traire",
      studAnimals: "Animaux reproducteurs",
      animalInseminationRecord: "Dossier d'insémination animale",
      numOfStrawsOrdered: "Nombre de pailles commandées",
      totalNumOfStraws: "Nombre total de pailles",
      strawId: "ID de paille",
      addSireAutomation: "Ajouter Sire Automation",
      addApprovalAutomation: "Ajouter l'automatisation des approbations",
      addCollectionAutomation: "Ajouter une automatisation de collecte",
      addStrawsAutomation: "Ajouter des pailles Automatisation",
      addPackAutomation: "Ajouter l'automatisation des packs",
      addPostageAutomation: "Ajouter l'automatisation de l'affranchissement",
      searchBySire: "rechercherParSire",
      numberOfProgenies: "Nombre de descendants",
      sireEdit: "Père Modifier",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "Recherche par ID de paille, nombre total de pailles, numéro de lot et ID d'emplacement",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "Recherche par Pack Id, Nombre de pailles commandées, Packing Technicia",
      searchByCollectionAndPreparationTechnicia: "Recherche par technique de collecte et de préparation",
      registerSemenAutomation: "Enregistrer l'automatisation du sperme",
      addSemenAutomation: "Ajouter l'automatisation du sperme",
      strawAutomationRegistered: "Automatisation de la paille enregistrée",
      strawAutomationRegisteredNotRegistered: "Straw Automation Enregistré non enregistré",
      sireAutomationRegistered: "Sire Automation Enregistré",
      sireAutomationNotRegistered: "Sire Automation non enregistré",
      postageAutomationIsRegistered: "L'automatisation de l'affranchissement est enregistrée",
      postageAutomationNotRegistered: "Automatisation d'affranchissement non enregistrée",
      packAutomationIsRegistered: "Pack Automation est enregistré",
      packAutomationNotRegistered: "Automatisation de pack non enregistrée",
      postageAutomationIsUpdated: "L'automatisation de l'affranchissement est mise à jour",
      postageAutomationNotUpdated: "Automatisation de l'affranchissement non mise à jour",
      packAutomationIsUpadted: "Pack Automation est mis à jour",
      packAutomationNotUpadted: "Automatisation des packs non mise à jour",
      collectionAutomationUpdated: "Automatisation de la collecte mise à jour",
      collectionAutomationNotUpdated: "Automatisation de la collecte non mise à jour",
      approvalAutomationIsUpdated: "L'automatisation des approbations est mise à jour",
      approvalAutomationIsNotUpdated: "L'automatisation des approbations n'est pas mise à jour",
      collectionAutomationRegistered: "Automatisation de la collecte Enregistré",
      collectionAutomationNotRegistered: "Automatisation de collecte non enregistrée",
      approvalAutomationIsRegistered: "L'automatisation des approbations est enregistrée",
      approvalAutomationIsNotRegistered: "L'automatisation de l'approbation n'est pas enregistrée",
      strawAutomationUpdated: "Mise à jour de l'automatisation de la paille",
      strawAutomationIsNotUpdated: "L'automatisation de la paille n'est pas mise à jour",
      searchSire: "Rechercher un père",
      strawsEdit: "Pailles Modifier",
      nextAnimals: "Animal suivant",
      performanceInfo: {
        milk: "Lait",
        liveweight: "Poids vif",
        score: "Score",
        fertility: "La fertilité",
        measurements: "Des mesures",
        dailyProteinYield: "Rendement quotidien en protéines",
        amountProteinMilkCowDay: "Quantité de protéines dans le lait provenant d'une vache au cours d'une journée particulière.",
        dailyMilkYield: "Rendement laitier journalier",
        volumeMilkCowDay: "Volume de lait obtenu d'une vache particulière en un jour particulier.",
        dailyFatYield: "Rendement quotidien en graisse",
        amountFatMilkCowDay: "Quantité de matières grasses dans le lait provenant d'une vache au cours d'une journée donnée.",
        dailyProteinContent: "Teneur quotidienne en protéines",
        dailyFatContent: "Teneur quotidienne en matières grasses",
        milkLactose: "Lait Lactose",
        amountLactoseMilk: "Quantité de lactose dans le lait.",
        milkUrea: "Urée de lait",
        indicatorAmountCrudeProtein: "Indicateur de la quantité de protéines brutes dans l'alimentation d'une vache",
        lactationNumber: "Numéro de lactation",
        ordinalNumLactation: "Le nombre ordinal de lactation.",
        lengthOfLactation: "Durée de la lactation (par exemple 23 jours)",
        lactationLength: "Durée de la lactation",
        milkingFrequency: "Fréquence de traite",
        frequcnyOfMilking: "Fréquence de traite (par exemple 2 fois/jour)",
        liveWeightInformation: "Informations sur le poids vif",
        currentWeight: "Poids actuel",
        weightAnimal: "Poids de l'animal.",
        postWeaningGain: "Gain post-sevrage",
        dailyGainInAnimalWeightWeaning: "Gain de poids journalier de l'animal après sevrage.",
        weaningWeight: "Poids au sevrage",
        weightAnimalMeasuredWeaning: "Poids de l'animal mesuré en un jour de sevrage.",
        averageDailyGain: "Gain quotidien moyen",
        averageAmountWeightAnimalGainFeedingPeriod: "La quantité moyenne de poids qu'un animal gagnera chaque jour pendant la période d'alimentation",
        carcassWeight: "Poids carcasse",
        weightAnimalsHideInternalOrgansRemoved: "Poids des animaux après enlèvement de la tête, de la peau et des organes internes.",
        weightAtCalving: "Poids au vêlage",
        weightAtTheTimeOfCalving: "Poids au moment du vêlage.",
        yearlingWeight: "Poids d'un an",
        weightYearOldAnimal: "Poids d'un animal d'un an.",
        somaticCellScore: "Score des cellules somatiques",
        somaticCellScoreIndicatorMastitis: "Score des cellules somatiques comme indicateur de mammite. ",
        lastUpdate: "Dernière mise à jour",
        bodyConditionScore: "Note d'état corporel",
        scoreAnimalFat: "Un score d'animal par rapport au nombre de graisses dont il dispose.  ",
        teatScore: "Score des trayons",
        scoreMeasureingShapeTeats: "Les scores de taille des trayons sont des évaluations subjectives de la longueur et de la circonférence des trayons et vont de 9 (très petit) à 1 (très grand). ",
        udderScore: "Score de suspension du pis",
        scoreMeasureingShapeOfUdder: "Score mesurant la forme du pis (score de 1 à 9). ",
        whetherAnimalEasyBirthDifficult: "La naissance chez le bétail est un processus naturel, mais parfois il peut y avoir des problèmes de naissance où le barrage a besoin de l'aide de l'agriculteur/éleveur.",
        totalLongevity: "Longévité totale",
        survivalLactationTraitCowCulledBreeding: "Survie de la 1ère à la 5ème lactation. ",
        docility: "Docilité",
        circumferenceBullScrotal: "Circonférence du scrotum du taureau",
        intervalSuccessInsemination: "Intervalle entre la première et la réussite de l'insémination.",
        ageAtFirstCalving: "Âge au premier vêlage",
        ageCowCalving: "Quel est l'âge de la vache au premier vêlage.",
        calvingInterval: "Intervalle de vêlage",
        periodCalving: "La période d'un vêlage au vêlage suivant.",
        scrotalCircumference: "Circonférence scrotale",
        estrusDetection: "Détection de l'œstrus",
        trackingBehaviorAnimalDetectingEstrus: "Suivi du comportement de mouvement d'un animal pour détecter l'œstrus d'une vache.",
        presenceOfEstrus: "Présence d'œstrus",
        isCowInEstrusStage: "C'est quand une vache est en oestrus ou ni",
        matureWeight: "Poids à maturité",
        weightAnimalDefinedAge: "Poids d'un animal à un âge défini.",
        matureHeight: "Taille adulte",
        heightAnimalDefinedAge: "Taille d'un animal à un âge défini.",
        footClawSet: "Ensemble de griffes de pied",
        shapeAnimalClaw: "Forme de griffe d'animal.",
        pulmonaryArterialPressure: "Pression artérielle pulmonaire",
        animalBloodPreasure: "La pression sanguine de l'animal.",
        footAngle: "Angle du pied",
        shapeAnimalFoot: "Forme du pied de l'animal.",
        ribEyeArea: "Zone de faux-filet",
        amountRibEyeArea: "Quantité de zone de faux-filet.",
        ultrasoundFat: "Graisse à ultrasons",
        measureFatAmount: "Mesure de la quantité de graisse.",
        ultrasoundIntramuscularFat: "Graisse intramusculaire à ultrasons",
        ultrasoundRibEyeArea: "Zone échographique Rib-Eye",
        measureRibeyeArea: "Mesure de la zone de faux-filet.",
        fatThickness: "Épaisseur de graisse",
        anmountAnimalBackFat: "Quantité de gras dorsal de l'animal.",
        marbling: "Marbrure",
        marballingMeasurement: "La marbrure est la graisse intramusculaire insaturée (saine) visible qui s'accumule dans le muscle et entre les faisceaux de fibres musculaires.",
        dryMatterIntake: "Apport de matière sèche",
        amountFeedAnimalConsumesAMoisture: "Quantité de nourriture qu'un animal consomme par jour sans humidité."
      },
      feedsName: "Nom du flux",
      feedName: "Nom du flux",
      firstFeedQuantity: "Première quantité d'alimentation",
      additionalFeed: "Flux supplémentaire",
      cloversRyeGrasses: "Trèfles, Rye grass",
      greenFodderHayLegumes: "Fourrage vert, Foin, Légumineuses",
      feedsRegisteredSuccessfully: "Flux enregistrés avec succès",
      feedsNotRegistered: "Flux non enregistrés",
      fEEDQUANTITY: "QUANTITÉ D'ALIMENTATION",
      feedQuantity: "Quantité d'alimentation",
      fEEDNAME: "NOM DU FLUX",
      nOFEEDINFOAVAILABLE: "AUCUNE INFORMATION SUR LE FLUX DISPONIBLE",
      searchByFeedName: "Rechercher par nom de flux",
      loadingFeedInfo: "Chargement des informations sur le flux... Veuillez patienter",
      todayFeedInfo: "Informations sur le flux d'aujourd'hui",
      feedInfo: "Informations sur le flux",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "Si cette valeur d'élevage est utilisée pour le calcul de l'indice économique.",
        dailyProteinYieldUsed: "Rendement quotidien en protéines utilisé",
        weightAssignedBreedingDailyProteinYield: "Poids attribué à la valeur d'élevage correspondant au \"Rendement protéique journalier\". ",
        dailyProteinYieldWeight: "Poids du rendement quotidien en protéines",
        rankAnimalInRelationshipEconomicIndex: "Rang de l'animal par rapport à l'indice économique.",
        economicIndexRank: "Classement de l'indice économique",
        percentileEconomicIndexFall: "Centile dans lequel se situe l'indice économique.",
        economicIndexPercentile: "Centile de l'indice économique",
        accuracyOfEconomicIndex: "Précision de l'indice économique.",
        economicIndexAccuracy: "Précision de l'indice économique",
        weightedAverageOfBreedingValues: "Moyenne pondérée des valeurs d'élevage.",
        economicIndex: "Indice économique",
        rankOfAnimalInRelationshipBreeding: "Rang de l'animal par rapport à la valeur d'élevage correspondante.",
        dailyProteinYieldBreedingValueRank: "Classement de la valeur d'élevage du rendement quotidien en protéines ",
        percentileBreedingFalls: "Percentile dans lequel se situe la valeur d'élevage.",
        dailyProteinYieldBreedingPercentile: "Percentile de la valeur d'élevage du rendement quotidien en protéines ",
        accuracyEstimatedBreeding: "Précision de la valeur d'élevage estimée.",
        dailyProteinYieldBreedingAccuracy: "Précision de la valeur d'élevage du rendement quotidien en protéines",
        estimatedBreedingTraitDailyProteinYield: "Valeur d'élevage estimée du caractère \"Rendement quotidien en protéines.",
        dailyProteinYieldBreedingValue: "Valeur d'élevage du rendement quotidien en protéines ",
        pathToTheDirectoryScriptsBreeding: "Chemin d'accès au répertoire sur le disque dur contenant les scripts utilisés pour le calcul de la valeur d'élevage.",
        scriptsPath: "Chemin des scripts",
        softwarePackageBreeding: "Progiciel utilisé pour calculer la valeur d'élevage.",
        breedingValueSoftware: "Logiciel de valeur d'élevage",
        methodCalculateBreeding: "La méthode utilisée pour calculer la reproduction",
        breedingValueMethod: "Méthode de la valeur d'élevage",
        trait: "Trait",
        tools: "Outils",
        geneticWorth: "Valeur génétique",
        dailyProteinYield: "Rendement quotidien en protéines",
        breedingValue: "Valeur d'élevage",
        breedingValueBIFAccuracy: "Valeur d'élevage Précision BIF",
        breedingValuePercentile: "Centile de la valeur d'élevage",
        breedingValueRank: "Classement de la valeur d'élevage",
        checkLTD: "Chèque LTD",
        ultrasoundDiagnostic: "Diagnostic par ultrasons",
        selectYieldUsed: "Sélectionnez Rendement utilisé",
        softwareName: "Nom du logiciel",
        animalGenWorthUpdatedSuccessfully: "Animal Gen Worth mis à jour avec succès"
      },
      addNote: "Ajouter une note",
      enterNote: "Entrer une remarque",
      noteIsRequired: "Remarque obligatoire",
      noteMustBeLessThan50Characters: "La note doit comporter moins de 50 caractères",
      noteAdded: "Remarque ajoutée",
      noteNotAdded: "Remarque non ajoutée",
      noteForAnimal: "Remarque pour les animaux.",
      noNoteFoundForThisAnimal: "Aucune note trouvée pour cet animal.",
      inseminationData: "Données d'insémination",
      nameOfInseminator: "Nom de l'inséminateur",
      activity: "Activité",
      searchByNameActivity: "Recherche par nom, activité",
      searchByTaskNameNumber: "Rechercher par nom de tâche, numéro",
      inseminationDate: "Date d'insémination",
      genotypeDataInfo: {
        genotypeAnimalID: "Génotype Animal ID",
        iDTubeBloodSampleAnimalNumberGenotypingService: "Il s'agit de l'identification d'un tube avec un échantillon de sang prélevé sur l'animal ou d'un numéro de service de génotypage",
        geneticTechnicianName: "Nom du technicien en génétique",
        NameTechnicianBloodSamplesAnimal: "C'est le nom d'un technicien qui a prélevé des échantillons de sang sur l'animal",
        sNPData: "Données SNP",
        genotypingServiceNote: "Note de service de génotypage",
        InfoGenotypingGenotypingTechnology: "Toutes les informations relatives au génotypage telles que le nom de la société de génotypage, la technologie de génotypage utilisée, la date du génotypage, etc.",
        numberOfSNPs: "Nombre de SNP",
        numberOfSNPsAnimalGenotyped: "Nombre de SNP pour lesquels l'animal a été génotypé",
        nameOfTheDrug: "Nom du médicament",
        animalGenoDataUpdatedSuccessfully: "Données génétiques animales mises à jour avec succès",
        animalGenoDataNotUpdated: "Données génétiques animales non mises à jour",
        animalIDIsRequired: "L'identification de l'animal est requise",
        techNameIsRequired: "Technologie. ",
        onlyAlphabetsAreAllowed: "Seuls les alphabets sont autorisés",
        genoDataIsRequired: "Les données Geno sont requises",
        serviceNoteIsRequired: "La note de service est requise",
        sNPIsRequired: "SNP est requis"
      },
      healthRecordInfo: {
        treatment: "Traitement",
        treatmentTakenAnimal: "Quel traitement a été pris sur l'animal.",
        reasonOfTreatment: "Raison du traitement",
        reasonForTreatment: "Raison du traitement",
        whatReasonOfTreatment: "Quelle est la raison du traitement.",
        treatmentDate: "Date de traitement",
        dateOfTreatment: "Date du traitement.",
        diagnosis: "Diagnostic",
        nameDiagnosedDiseaseConditionSymptoms: "Nom de la maladie/affection diagnostiquée ou des principaux symptômes",
        drugID: "Identification du médicament",
        iDOfDrugWhichIsGivenToAnimal: "ID du médicament administré à l'animal.",
        drugName: "Nom du médicament",
        nameDrugAnimal: "Nom du médicament administré à l'animal.",
        drugWithdrawalPeriod: "Période d'attente du médicament",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "Le temps nécessaire après l'administration d'un médicament à un animal pour assurer la sécurité de la viande ou du lait destiné à la consommation humaine",
        attendingVeterinarian: "Vétérinaire traitant",
        qualifiedPersonCaseAnimal: "La personne qualifiée qui a vu le cas/l'animal",
        packID: "ID de pack",
        iDPackTreatment: "ID d'un pack qui a été utilisé pour le traitement",
        veterinarianName: "Nom du vétérinaire",
        animalNoHealthRecord: "Cet animal n'a pas de carnet de santé. ",
        addHealthRecord: "Ajouter un dossier médical",
        healthStatus: "État de santé",
        loadingDiseasesPleaseWait: "Chargement des maladies... Veuillez patienter",
        animalDiseaseRecord: "Registre des maladies animales",
        animalHealthRecord: "Dossier de santé animale",
        animalTreatmentRecord: "Dossier de traitement des animaux",
        loadingHealthData: "Chargement des données de santé...",
        healthRecord: "Carnet de santé",
        nameOfDiagnosis: "Nom du diagnostic",
        treatmentName: "Nom du traitement",
        drugGivenBy: "Médicament administré par",
        recessiveDiseases: "Maladies récessives",
        recessiveDiseasesMessage: "De quel allèle de maladie récessive ce taureau est-il porteur ?"
      },
      conceptionInfo: {
        addNewConception: "Ajouter une nouvelle conception",
        semenEmbryo: "Sperme/Embryon",
        pregnancyCheck: "Contrôle de grossesse",
        birthInfo: "Informations sur la naissance",
        searchByInseminatorOrganisationBreedingConception: "Recherche par nom d'inséminateur, nom d'organisation, numéro de service d'élevage, méthode de conception",
        deliveryDate: "La date de livraison",
        calfId: "ID de veau",
        birthDayOldWeight: "Poids à la naissance (jour)",
        searchByBirthEase: "Recherche par facilité de naissance",
        searchPregnancyCheckOperatorMethod: "Recherche par Opérateur de contrôle de grossesse, Méthode de contrôle de grossesse",
        pregnancyCheckDate: "Date du contrôle de grossesse",
        conceptionSuccess: "Succès de la conception",
        pregnancyCheckOperator: "Opérateur de contrôle de grossesse",
        pregnancyCheckMethod: "Méthode de contrôle de grossesse",
        recentlyPregnant: "Récemment enceinte",
        pregnancyConfirmationDate: "Date de confirmation de grossesse",
        pregnancyRate: "Taux de grossesse",
        timePeriodOfPregnancy: "Période de grossesse",
        semenProduction: "Production de sperme",
        embryoProduction: "Production d'embryons",
        semen: "sperme",
        embryoTransferDate: "Date de transfert d'embryon",
        daysOfPregnancy: "Jours de grossesse",
        searchSireEmbryoSurrogate: "Recherche par ID de père, nom d'org d'embryon, race de mère porteuse",
        selectDate: "Sélectionner une date",
        orgnisationNameContainNumber: "Le nom de l'organisation ne doit pas contenir de chiffre",
        selectBirthEase: "Sélectionnez la facilité de naissance",
        selectUnit: "Veuillez sélectionner une unité",
        animalConceptionAddedSuccessfully: "Conception animale ajoutée avec succès",
        postageCustomerName: "Nom du client d'affranchissement",
        searchByPostageCustNameCustAddPostId: "Recherche par nom de client d'affranchissement, adresse de client, identifiant de poste",
        dateOfSemenCollection: "Date du prélèvement de sperme",
        dateOfSemenPreparation: "Date de préparation du sperme",
        semenMotility: "Motilité du sperme",
        semenConcentration: "Concentration de sperme",
        postageEdit: "Affranchissement Modifier",
        enterSireId: "Entrez l'ID du père",
        selectEmbryoOrganisation: "Sélectionnez l'organisation de l'embryon",
        matingDateH: "Date de conception, soit saillie naturelle, soit insémination artificielle.",
        inseminatorNameH: "Une personne qui effectue le processus d'insémination (vétérinaire/technicien)",
        orgNameH: "Nom de l'organisation ou de l'entreprise qui fournit la paillette de sperme pour l'IA",
        brServiceNumH: "Enregistrement du nombre de reproductions (par exemple, 1er, 2e ou 3e)",
        conceptionMethodH: "La façon dont l'animal a conçu c'est le début de la grossesse, marqué par la fécondation d'un ovule par un spermatozoïde.",
        sireIdH: "L'ID du parent mâle/père de l'animal",
        damIdH: "L'ID du parent femelle/mère de l'animal.",
        sarogatedDamH: "L'ID de la vache femelle dans laquelle l'ovule fécondé d'un mâle donneur et d'une femelle donneuse est implanté pour son développement ultérieur.",
        embOrgNameH: "Le nom de l'organisation pour l'embryon",
        sarogateDamBreedH: "La date de la race de substitution",
        sireBreedH: "Le type de la race paternelle (brahman, boran)",
        pregCheckDateH: "La grossesse peut être détectée chez les vaches dès 30 jours à l'aide d'échographies et de tests sanguins. ",
        conceptionSuccessH: " Chez les bovins, le taux de fécondation est de 90% avec un taux de vêlage moyen d'environ 55%, indiquant une mortalité embryo-fœtale d'environ 35% (Diskin et al., 2006). ",
        pregnancyCheckOperatorH: "Les vétérinaires et les techniciens animaliers spécialisés fournissent le plus souvent ces services aux éleveurs. ",
        pregnancyCheckMethodH: "Les deux méthodes les plus fréquemment utilisées pour le diagnostic de gestation chez les bovins sont la palpation manuelle de l'appareil reproducteur (per rectum) et l'échographie transrectale de l'appareil reproducteur.",
        deliveryDateH: "Date à laquelle l'accouchement a eu lieu",
        calfIdH: "ID du veau nouveau-né",
        birthEaseH: "La naissance chez le bétail est un processus naturel, mais il peut parfois y avoir des problèmes de naissance où le barrage a besoin de l'aide de l'agriculteur/pasteur.",
        birthDayOldWeightH: "Poids d'un animal le jour de sa naissance ou poids d'un oiseau d'un jour",
        customerAddress: "Adresse du client"
      },
      all: "Tous",
      ungrouped: "Animaux non groupés",
      active: "Animaux groupés",
      updateAnimal: "Mettre à jour l'animal"
    },
    dashboardS: {
      dailyActivities: "Activités quotidiennes",
      pendingTasks: "Tâches en attente",
      performanceOfGeno: "Performances des génotypes",
      breed: "Race",
      chromosome: "Chromosome",
      seqChange: "Changement de séquence",
      inheritance: "Héritage",
      diseaseName: "Nom de la maladie",
      refSequence: "Séquence de référence",
      pubmedRef: "Référence Pubmed",
      matingDate: "Date d'accouplement",
      inseminatorName: "Nom de l'inséminateur",
      orgName: "nom de l'organisation",
      brServiceNum: "Numéro de service d'élevage",
      conceptionMethod: "Méthode de conception",
      semEmbInfo: "Informations sur le sperme/l'embryon",
      sireId: "ID du père",
      damID: "ID du barrage",
      srgDamId: "ID de la mère de substitution",
      embOrgName: "Embryon Org. ",
      srgDamBreed: "Race maternelle de substitution",
      sireBreed: "Race de père",
      damBreed: "Race maternelle"
    },
    user: {
      selectLanguage: "Choisir la langue",
      unitPreference: "Préférence d'unité",
      selectUnitOfMeasure: "Sélectionnez l'unité de mesure",
      importedUser: "Utilisateur importé",
      impFileStatus: "État du fichier d'importation",
      loadingUser: "Chargement des utilisateurs... Veuillez patienter",
      totalUsers: "Nombre total d'utilisateurs",
      pendingUsers: "Utilisateurs en attente",
      changePassword: "Changer le mot de passe",
      goodIdeaToUsePassword: "C'est une bonne idée d'utiliser un mot de passe fort que vous n'utilisez pas ailleurs.",
      enterCurrentPassword: "Entrer le mot de passe actuel",
      enterNewPassword: "Entrez un nouveau mot de passe",
      reEnterPassword: "Ré-entrez le nouveau mot de passe",
      enterPassword: "Entrer le mot de passe",
      repeatNewPassword: "Répété le nouveau mot de passe",
      emailAddr: "Adresse e-mail",
      enterYourPhoneNumber: "Entrez votre numéro de téléphone",
      pleaseTypeOldPassword: "Veuillez saisir l'ancien mot de passe.",
      pleaseTypeNewPassword: "Veuillez saisir un nouveau mot de passe.",
      pleaseTypeConfirmPassword: "Veuillez saisir le mot de passe de confirmation.",
      passwordChangedSuccesFully: "Le mot de passe a été changé avec succès",
      currentPassword: "Mot de passe actuel",
      newPassword: "nouveau mot de passe",
      passwordDoesNotMatch: "Les mots de passe ne correspondent pas.",
      emailCanNotBeEmpty: "L'e-mail ne peut pas être vide",
      profileUpdated: "Profil mis à jour",
      profileNotUpdated: "Profil non mis à jour",
      unableToVerifyEmail: "Impossible de vérifier l'e-mail",
      otpSentOnEmail: "OTP envoyé par e-mail",
      otpSentSuccessFully: "OTP envoyé avec succès",
      importUsers: "Importer des utilisateurs",
      imageUpdated: "Image mise à jour",
      departmentName: "Nom du département",
      departmentNum: "Numéro de département",
      departmentAdded: "Département ajouté",
      departmentNotAdded: "Département non ajouté",
      searchDepartnment: "Rechercher par nom ou numéro de service",
      addDepartMent: "Ajouter un département",
      addDepartment: "Ajouter un département",
      roleNameIsRequired: "Le nom du rôle est requis",
      roleNameMustBeLessThan15Chars: "Le nom du rôle doit comporter moins de 15 caractères",
      roleAdded: "Rôle ajouté",
      editDepartment: "Modifier le département",
      departmentUpdated: "Département mis à jour",
      departmentNotUpdated: "Département non mis à jour",
      deleteDepartment: "Supprimer le département",
      deleteDepartmentMessage: "Voulez-vous vraiment supprimer ce département ?",
      noRoleAvailable: "AUCUN RÔLE DISPONIBLE",
      roleUpdated: "Rôle mis à jour",
      roleNotUpdated: "Rôle non mis à jour",
      editRole: "Modifier le rôle",
      allRole: "Tous les rôles",
      addNewRole: "Ajouter un nouveau rôle",
      allDepartment: "Tous les départements",
      permissionsUpdated: "Autorisations mises à jour",
      permissionsnotUpdated: "Autorisations non mises à jour",
      roleNo: "N° de rôle",
      searchByEmailAndName: "Recherche par email et nom",
      userID: "ID de l'utilisateur",
      userUpdated: "Utilisateur mis à jour",
      userNotUpdated: "Utilisateur non mis à jour",
      userAdded: "Utilisateur ajouté",
      userNotAdded: "Utilisateur non ajouté",
      activateUser: "Activer l'utilisateur",
      deactivateUser: "Désactiver l'utilisateur",
      userStatusMsg: "Voulez-vous vraiment modifier le statut de l'utilisateur ?",
      countryRequired: "Le pays est requis",
      stateRequired: "L'état est requis",
      cityRequired: "La ville est obligatoire",
      searchByRole: "Rechercher par numéro de rôle, nom de rôle, département",
      noModuleAvailable: "Aucun module disponible",
      searchBYModuleName: "Rechercher par nom de module"
    },
    farm: {
      farmID: "ID de la ferme",
      onTheFarm: "À la ferme",
      userRoles: "Rôles d'utilisateur",
      adduser: "Ajouter un utilisateur",
      addAuser: "Ajouter un utilisateur",
      uploadUsers: "Télécharger des utilisateurs",
      addNewUser: "Ajouter un nouvel utilisateur",
      selectDept: "Sélectionnez le département",
      selectRole: "Sélectionnez un rôle",
      editUser: "Modifier l'utilisateur",
      totalFarms: "Nombre total de fermes",
      NoAnimalsRegisteredForthisFarm: "Aucun animal n'est enregistré pour cette ferme",
      farmsPerPage: "Fermes par page",
      regularFarms: "Fermes régulières",
      farmRegisteredProducts: "Produits enregistrés à la ferme",
      searchByFarmNameAndId: "Recherche par nom et identifiant de ferme",
      loadingProductsPleaseWait: "Chargement des produits... Veuillez patienter",
      farmName: "Nom de la ferme",
      farmLocation: "Emplacement de la ferme",
      productName: "Nom du produit",
      stockStatus: "État des stocks",
      inStock: "En stock",
      searchByProductName: "Rechercher par nom de produit",
      productCategory: "catégorie de produit",
      products: "Des produits",
      farms: "Fermes",
      registerAfarm: "Enregistrer une ferme",
      govtRegistry: "Gouv. ",
      cooperativeID: "Identifiant coopératif",
      farmType: "Type de ferme",
      contractMating: "Accouplement sous contrat",
      customization: "Personnalisation",
      recordsPerpage: "Enregistrements par page",
      restoreDefault: "Restaurer par défaut",
      apply: "Appliquer",
      searchState: "Recherche par identifiant de ferme, registre gouvernemental, identifiant de coopérative, type de ferme, accouplement sous contrat",
      farmOwner: "Propriétaire de la ferme",
      govRegistrationNo: "Numéro d'enregistrement gouvernemental",
      farmInformation: "Informations sur la ferme",
      ownershipType: "Type de propriété",
      communityName: "Nom de la communauté",
      farmLicenseInformation: "Informations sur la licence agricole",
      licenseNumber: "Numéro de licence",
      licenseExpiryDate: "Date d'expiration de la licence",
      regulatorName: "Nom du régulateur",
      regulatorRepresentativeName: "Nom du représentant de l'organisme de réglementation",
      farmLocationSize: "Emplacement de la ferme",
      productionSystem: "Système de production",
      country: "Pays",
      state: "État",
      city: "Ville",
      street: "Rue",
      houseNumber: "Numéro de maison",
      farmRegistration: "Enregistrement de la ferme",
      cancel: "Annuler",
      register: "Enregistrer",
      ok: "d'accord",
      totalFarmSize: "Taille totale de la ferme",
      farmGeographicLocation: "Emplacement géographique de la ferme",
      perimeterPointLongitude: "Longitude du point de périmètre",
      perimeterPointLatitude: "Latitude du point de périmètre",
      perimeterPointLabel: "Étiquette de point de périmètre",
      perimeterLength: "Longueur du périmètre",
      farmLatitude: "Latitude de la ferme",
      farmLongitude: "Longitude de la ferme",
      editFarm: "Modifier la ferme",
      update: "Mise à jour",
      editAfarm: "Modifier une ferme",
      nextFarm: "Ferme suivante",
      nameoftheFarm: "Nom de la ferme",
      registerAProduct: " Enregistrer un produit",
      farmProducts: "Produits de la ferme",
      calf: "Veau",
      steer: "Diriger",
      heifer: "Génisse",
      sire: "Sire",
      dam: "Barrage",
      registerAnAnimal: "Enregistrer un animal",
      farmAnimals: "Animaux de la ferme",
      farm_type: "Type de ferme",
      farm_Owner: "Propriétaire de ferme",
      dateOfRegistration: "Date d'enregistrement",
      dataIsNotAvailableForThisFarm: "Les données ne sont pas disponibles pour cette ferme",
      registerNewProduct: "Enregistrer un nouveau produit",
      information: "Information",
      licenseInfo: "Informations sur la licence",
      locationInfo: "Informations sur l'emplacement",
      geoLocation: "Emplacement géographique",
      perimeterLengthState: "Longueur du périmètre des fermes (longueur de la clôture)",
      totalFarmSizeState: "Taille d'une ferme",
      productionSystemState: "Système de production utilisé dans la ferme",
      contractMatingState: "Code du programme d'accouplement contractuel auquel la ferme participe.",
      ownershipTypeState: "Type de propriété",
      regulatorRepresentativeNameState: "Nom de la personne représentant le régulateur qui a délivré la licence",
      regulatorNameState: "Nom du régulateur qui a délivré la licence",
      licenseExpiryDateState: "Date d'expiration de la licence actuelle",
      licenseNumberState: "Numéro de licence publié par le régulateur",
      plotNumberState: "Numéro de maison de la ferme.",
      plotNumber: "Numéro de maison/terrain",
      streetStatement: "Nom de la rue de la ferme.",
      cityStatement: "Ville où se situe la ferme.",
      stateStatement: "Région du pays où se trouve la ferme.",
      countryState: "Pays où se situe la ferme.",
      perimeterPointLongitudeState: "Longitude d'un point sur la ferme.",
      perimeterPointLatitudeState: "Latitude d'un point sur la ferme.",
      perimeterPointLabelState: "Étiquette de point.",
      farmLongitudeState: "Longitude de la ferme.",
      farmLatitudeState: "Latitude de la ferme.",
      farmNameH: "Nom de la ferme",
      farmTypeH: "Le type de ferme où différentes activités sont exercées.",
      farmOwnerH: "Nom du propriétaire d'une ferme (générer automatiquement le nom du fermier en saisissant les informations)",
      ownershipTypeH: "Le type d'agriculteurs qui possèdent/contrôlent les terres qu'ils exploitent et ceux qui n'en possèdent pas.",
      govtRegNumbH: "Numéro d'enregistrement de la ferme qui a été attribué par le régulateur",
      contractMatingH: "Code du programme d'accouplement contractuel auquel la ferme participe",
      productionSystemH: "Quel est le système de production utilisé à la ferme",
      cooperativeIDH: "ID d'une coopérative dont la ferme est membre ",
      licenseNumberH: "Numéro d'identification sur une licence délivrée par le régulateur qui l'identifie avec le propriétaire.",
      licenseExpiryDateH: "Date d'expiration de la licence actuelle",
      regularNameH: "Nom du régulateur qui a délivré la licence",
      regularRepName: "Nom de la personne représentant le régulateur qui a délivré la licence",
      countryH: "Pays où se situe la ferme.",
      stateH: "Région du pays où se trouve la ferme.",
      cityH: "Ville où se situe la ferme.",
      streetH: "Nom de la rue de la ferme.",
      houseNumberH: "Numéro de maison de la ferme.",
      totalFarmSizeH: "La taille de l'exploitation est la somme des terres actuellement cultivées par l'exploitation, y compris les terres en jachère, mais à l'exclusion des terres sous végétation naturelle, arbres ou pâturages.",
      farmLatitudeH: "Est la mesure de la distance au nord ou au sud de l'équateur. ",
      farmLongitudeH: "Il mesure la distance à l'est ou à l'ouest du premier méridien.",
      perimeterLengthH: "Longueur du périmètre des fermes (longueur de la clôture)",
      perimeterPointLabelH: "Étiquette de point. ",
      perimeterPointLatH: "Latitude d'un point sur la ferme",
      perimeterPointLongH: "Longitude d'un point sur la ferme",
      noProductAvailable: "Aucun produit disponible",
      farmUpdated: "Mise à jour de la ferme",
      performance: "Performance",
      milkInformation: "Informations sur le lait",
      farmNameRequired: "Le nom de la ferme est requis"
    },
    login: {
      welcome: "Accueillir! ",
      welInfo: "Entrez vos informations d'identification.",
      login: "Connexion",
      forgotPassword: "Mot de passe oublié",
      forgotPasswordDesc: "Veuillez saisir l'adresse e-mail associée à votre compte. ",
      backToLogin: "Retour connexion"
    },
    actionListmod: {
      actionList: "Liste d'action",
      tODAY: "Aujourd'hui",
      createTask: "Créer une tâche",
      myActivities: "Mes activités",
      jhonSmith: "John Smith",
      farmID: "ID de la ferme",
      dateOfEvent: "Date de l'évènement",
      actionRequired: "Action requise",
      actionTaken: "Action prise",
      animalEventID: "ID d'événement animal",
      cANCEL: "Annuler",
      cONFIRM: "Confirmer",
      sTATEMENT: "Voulez-vous vraiment supprimer cet enregistrement ?",
      dAY: "Jour",
      wEEK: "Semaine",
      mONTH: "Mois",
      sUBMIT: "Soumettre",
      startDate: "Date de début",
      endDate: "Date de fin",
      rEPEAT: "Répéter",
      taskCategory: "Catégorie de tâche",
      pRIORITY: "Priorité",
      aSSIGNEE: "Cessionnaire",
      selectLocation: "Sélectionnez l'emplacement",
      selectAnimals: "Sélectionnez un ou plusieurs animaux",
      dESCRIPTION: "Description",
      customRecurrence: "Récurrence personnalisée",
      repeatEvery: "Répéter chaque",
      taskName: "Nom de la tâche",
      enterDescription: "Entrez la description",
      toDo: "Faire",
      assignTo: "Affecter à",
      status: "Statut",
      nOTE: "Note",
      noTaskAvailable: "AUCUNE TÂCHE DISPONIBLE",
      healthRecord: "Carnet de santé",
      iD: "IDENTIFIANT",
      tAG: "Étiqueter",
      dateOfbirth: "Date de naissance",
      taskTakenat: "Tâche effectuée à",
      gENDER: "Genre",
      bREED: "Race",
      regDate: "Rég. ",
      updateHealthRecord: "Mettre à jour le dossier de santé des animaux",
      treatment: "Traitement",
      reasonOftreatment: "Raison du traitement",
      treatmentDate: "Date de traitement",
      dIAGNOSIS: "Diagnostic",
      drugId: "Identifiant du médicament",
      drugName: "Nom du médicament",
      drugWithdrawalperiod: "Période d'attente du médicament",
      attendingVeterinarian: "Vétérinaire traitant",
      packId: "Identifiant du pack",
      noItemsselected: "Aucun élément sélectionné",
      healthRecordsubmission: "Soumission du dossier médical",
      inseminationRecordsubmission: "Soumission du dossier d'insémination",
      inseminatorName: "Nom de l'inséminateur",
      inseminatorId: "Identifiant de l'inséminateur",
      conceptionRate: "Taux de conception",
      dateOfmeasurement: "Date de mesure",
      recordSubmission: "Soumission d'enregistrement",
      uPDATE: "Mise à jour",
      updateTask: "Mettre à jour la tâche"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "Ajouter des informations sur l'inséminateur",
      inseminatorNumber: "Numéro d'inséminateur",
      loadingInseminatorPleaseWait: "Chargement de l'inséminateur... Veuillez patienter",
      searchByIDAndName: "Recherche par identifiant et nom",
      inseminatorInfoAdded: "Informations sur l'inséminateur ajoutées",
      inseminatorInfoNotAdded: "Informations sur l'inséminateur non ajoutées",
      inseminatorInfoUpdated: "Informations sur l'inséminateur mises à jour",
      inseminatorInfoNotUpdated: "Informations sur l'inséminateur non mises à jour",
      editAInseminatorInfo: "Modifier les informations sur l'inséminateur",
      inseminatorList: "Liste des inséminateurs",
      inseminatorInfoDetails: "Détails des informations sur l'inséminateur",
      updateInseminatorInfo: "Mettre à jour les informations sur l'inséminateur"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "Chargement des commandes... Veuillez patienter",
      addStocks: "Ajouter des actions",
      addStock: "Ajouter des actions",
      quantity: "Quantité",
      selectUnit: "Sélectionnez l'unité",
      farmProducts: "Produits de la ferme",
      cost: "Coût",
      transactionID: "identifiant de transaction",
      recipientID: "Identifiant du destinataire",
      orderID: "numéro de commande",
      recepientName: "Nom du destinataire",
      createAOrder: "Créer une commande",
      totalStocks: "Stocks totaux",
      orders: "Ordres",
      totalPending: "Total en attente",
      totalDelivered: "Total livré",
      searchByRecepientNameOrderIdRecepientId: "Rechercher par nom de destinataire, ID de commande, ID de destinataire",
      chooseTheDate: "Choisissez la date",
      transactionDate: "Date de la transaction",
      selectCategory: "Choisir une catégorie",
      volumeOfProduct: "Volume de produit",
      productQuantity: "La quantité de produit",
      productRecipientId: "Identifiant du destinataire du produit",
      productRecipientName: "Nom du destinataire du produit",
      productRecipientType: "Type de destinataire du produit",
      singleProduct: "Produit unique",
      orderPlaced: "Commande passée",
      orderNotPlaced: "Commande non passée",
      totalPrice: "Prix ​​total",
      currency: "Monnaie",
      selectCurrency: "Sélectionnez la devise",
      address: "Adresse",
      enterAddress: "Entrer l'adresse",
      attachments: "Pièces jointes",
      chooseFile: "Choisir le fichier",
      nameOfTheFarm: "Nom de la ferme",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500, lorsqu'un imprimeur inconnu a pris un",
      billedTo: "Facturé à",
      orderStatus: "Statut de la commande",
      selectStatus: "Sélectionnez le statut",
      cadbury: "Cadbury",
      totalAmount: "Montant total",
      deliveryCharges: "Frais de livraison",
      orderDetails: "détails de la commande",
      deliveryOnTime: "Livraison à temps",
      productID: "Identifiant du produit",
      productRegistration: "Enregistrement du produit",
      enterTheNameOfTheProduct: "Entrez le nom du produit",
      nameOfTheProduct: "Nom du produit",
      productAdded: "Produit ajouté",
      productNotAdded: "Produit non ajouté"
    },
    drug: {
      dRUGS: "Drogues",
      registerAdrug: "Enregistrer un médicament",
      sEARCH: "Recherche",
      genericName: "Nom générique",
      manufacturer: "Fabricant",
      distributor: "Distributeur",
      registrationDate: "Date d'inscription",
      drugRegistration: "Enregistrement des médicaments",
      drugInformation: "Informations sur les médicaments",
      packExpiration: "Expiration du pack",
      drugId: "Identification du médicament",
      drugName: "Nom du médicament",
      drugGenericname: "Nom générique du médicament",
      drugManufacturer: "Fabricant de médicaments",
      distributorName: "Nom du distributeur",
      drugRegistrationdate: "Date d'enregistrement du médicament",
      nextDrug: "Médicament suivant",
      editDrug: "Modifier le médicament",
      updateDrug: "Mettre à jour le médicament",
      deleteDrug: "Supprimer le médicament",
      noRecordfound: "Aucun Enregistrement Trouvé",
      addDrug: "Ajouter un médicament",
      statementDrug: "Le médicament a été supprimé.  ",
      cANCEL: "Annuler",
      cONFIRM: "Confirmer",
      sTATEMENT: "Voulez-vous vraiment supprimer cet enregistrement ?",
      ok: " d'accord",
      information: "Information",
      packOrder: "Commande de pack",
      packPrescription: "Pack Ordonnance",
      packReservation: "Réservation de forfaits",
      packLocation: "Emplacement de l'emballage",
      drugDozedam: "Dose de drogue en un jour pour le barrage",
      drugDozecalf: "Dose de médicament par jour pour le veau",
      drugFormate: "Présentation du médicament",
      drugDistributor: "Distributeur de médicaments",
      drugActiveingridents: "Ingrédients actifs du médicament",
      drugSubstitutionId: "ID de substitution de médicament",
      packId: "Identifiant du pack",
      packBatchNumber: "Numéro de lot de l'emballage",
      drugIdStatement: "Le numéro de lot du médicament.",
      drugNameSatement: "Le nom de marque annoncé sous lequel le médicament est vendu.",
      drugGenericnameStatement: "La composition chimique d'un médicament plutôt que le nom de marque annoncé sous lequel le médicament est vendu.",
      drugFormateSatement: "Le numéro de lot du médicament.",
      drugDozecalfSatement: "Pour connaître la quantité de médicament dose au veau.",
      drugDozedamStatement: "Pour connaître la quantité de dose de médicament à dam.",
      drugManufacturerStatement: "Détails du fabricant du médicament.",
      drugDistributorStatement: "Coordonnées du distributeur de médicaments.",
      drugRegistrationdateStatement: "Date d'enregistrement du médicament dans le pays concerné.",
      drugActiveingridentsStatement: "Liste des ingrédients actifs.",
      drugSubstitutionIdStatement: "ID des substitutions possibles pour le médicament dans le cas où le médicament principal est actuellement indisponible.",
      packIdStatement: "Code barre ou RF ID du pack.",
      packBatchNumberStatement: "Le numéro de lot attribué au pack par le fabricant.",
      locationWarehouseID: "Emplacement ID de l'entrepôt",
      locationWarehouseIDState: "ID de l'entrepôt où le pack est stocké.",
      locationRackID: "ID de rack d'emplacement",
      locationRackIDStatement: "ID du rack où le pack est stocké.",
      locationTierID: "ID de niveau d'emplacement",
      locationTierIDStatement: "ID du niveau sur le rack où le pack est stocké.",
      locationPositionID: "ID de poste",
      locationPositionIDStatement: "ID de la position sur un niveau où le pack est stocké.",
      storageTemperatureCondition: "Conditions de température de stockage",
      storageTemperatureConditionStats: "Condition de stockage du pack.",
      containerForm: "Formulaire de conteneur",
      containerFormStatement: "Forme du récipient dans lequel le médicament a été emballé.",
      consistQuantity: "Consiste en quantité",
      consistQuantityStatement: "Quantité de pilules, flacons, etc. dans le pack.",
      releaseId: "Identifiant de version",
      releaseIdStatement: "Identifiant attribué après que le pack a été pris par l'agriculteur.",
      releaseDate: "Date de sortie",
      releaseDateStatement: "Date à laquelle le pack a été retiré du stock par l'agriculteur.",
      packManufacturedDate: "Date de fabrication de l'emballage",
      packManufacturedDateStatement: "Date à laquelle le pack a été fabriqué.",
      packImportedDate: "Date d'importation du pack",
      packImportedDateStatement: "Date à laquelle le pack a été importé.",
      packExpirationDate: "Date d'expiration du pack",
      packExpirationDateStatement: "Date à laquelle le pack est expiré.",
      expiredSoonFlag: "Drapeau bientôt expiré",
      expiredSoonFlagState: "Avertissement concernant le pack qui expire bientôt.",
      packTotalVolumeLeft: "Volume total restant du paquet",
      packTotalVolumeLeftState: "Nombre total de packs avec les mêmes ingrédients restant en stock.",
      packOrderID: "ID de commande de pack",
      packOrderIDState: "ID qui a été attribué après avoir commandé le pack auprès du distributeur.",
      packQuantityOrdered: "Quantité d'emballage commandée",
      packQuantityOrderedState: "Nombre de packs commandés auprès du distributeur.",
      packPrice: "Prix ​​du pack",
      packPriceStatement: "Prix ​​du pack.",
      priceCurrency: "Devise du prix",
      packPricecurrency: "Devise du prix du pack",
      packPricecurrencyState: "Nom de la devise dans laquelle le prix est nominé.",
      packPaydate: "Date de paiement du pack",
      payDate: "Date de paiement",
      packPaydateState: "Date à laquelle le paiement a été versé au distributeur.",
      packShippingID: "Identifiant d'expédition du pack",
      shippingID: "ID d'expédition",
      packShippingIdState: "Identifiant d'expédition du pack lorsqu'il est arrivé du distributeur.",
      packShippingDate: "Date d'expédition du pack",
      shippingDate: "Date d'expédition",
      packShippingDateState: "Date d'arrivée du pack au stock.",
      packOrderStatus: "État de la commande de pack",
      packOrderStatusState: "Statut de la commande en cours.",
      recepientKeeperId: "Identifiant du détenteur du destinataire",
      recepientKeeperIdStatement: "Le nom de la personne/organisation qui a reçu le pack.",
      recepientFarmId: "ID de la ferme du destinataire",
      recepientFarmIdStatement: "ID de la ferme à laquelle appartient le destinataire de la drogue animale.",
      recepientAnimalId: "Identifiant de l'animal destinataire",
      recepientAnimalIdState: "ID de l'animal à qui le médicament (emballage) a été prescrit.",
      specialistComments: "Commentaires de spécialistes",
      specialistCommentsState: "Commentaires du spécialiste/vétérinaire sur la prescription.",
      specialistName: "Nom du spécialiste",
      specialistNameState: "Nom du spécialiste/vétérinaire qui a prescrit le médicament.",
      specialistID: "ID de spécialiste",
      specialistIDState: "ID du spécialiste/vétérinaire qui a prescrit le médicament.",
      reservedByKeeperId: "Réservé par l'identifiant du gardien",
      reservedByKeeperIdState: "Identifiant du détenteur qui a réservé le pack.",
      reservedByFarmId: "Réservé par ID de ferme",
      reservedByFarmIdState: "ID de la ferme pour laquelle le pack a été réservé.",
      reservationTimeoutDate: "Date d'expiration de la réservation",
      reservationTimeoutDateState: "Date à laquelle la réservation sera automatiquement annulée si le pack n'est pas acheté.",
      reservationTimeout: "Délai de réservation",
      reservationTimeoutState: "Nombre d'heures au bout desquelles la réservation sera automatiquement annulée si le pack n'est pas acheté ou pris",
      reservationDate: "Date de réservation",
      reservationDateState: "Date de réservation du pack.",
      reservationStatus: "Statut de réservation",
      reservationStatusState: "Statut de la réservation du pack. ",
      loadingDrugsPleaseWait: "Chargement des médicaments... Veuillez patienter",
      quantityOrder: "Quantité Commande",
      keeperID: "ID du gardien",
      timeoutDate: "Date d'expiration",
      warehouseID: "ID d'entrepôt",
      rackID: "ID de rack",
      tierID: "ID de niveau",
      positionID: "Identifiant du poste",
      temperatureCondition: "Conditions de température",
      manufactureDate: "Date de fabrication",
      importedDate: "Date d'importation",
      totalVolumeLeft: "Volume total restant"
    },
    reports: {
      myReports: "Mes rapports",
      satelliteReports: "Rapports satellites",
      weatherReports: "Bulletins météorologiques",
      pregnancyAnalytics: "Analytique de la grossesse",
      semenEmbroyAnalytics: "Analytique du sperme/de l'embryon",
      semenAnalytics: "Analytique du sperme",
      embryoAnalytics: "Analyse d'embryons",
      calfAnalytics: "Analytique des mollets",
      milkProduction: "Production de lait",
      totalMilkType: "Type de lait total",
      totalAnimalAnalytics: "Analyse totale des animaux",
      animalAnalytics: "Analytique animale",
      analyticsAndReporting: "Analyses et rapports",
      filterByCountry: "Filtrer par pays",
      filterByFarm: "Filtrer par ferme",
      filterByRegion: "Filtrer par région",
      filterByMonth: "Filtrer par mois",
      filterByDate: "Filtrer par date",
      filterByRole: "Filtrer par rôle",
      filterByYear: "Filtrer par année",
      filterByTrait: "Filtrer par trait",
      avgBreedingValue: "Valeur d'élevage moyenne",
      avgEconomicIndex: "Indice économique moyen",
      breederReport: "Rapport de l'éleveur",
      semenTransferDate: "Date de transfert de sperme",
      semenEmbryoProductionReport: "Rapport de production de sperme/embryon",
      semenProducts: "Produits de sperme",
      meatProducts: "Produits carnés",
      totalProducts: "Produits totaux",
      semenEmbryoReport: "Rapport Sperme/Embryon",
      numOfStraws: "Nombre de pailles",
      collectionDate: "Date de collecte",
      productionReport: "Rapport de production",
      receipientId: "Identifiant du destinataire",
      embryoId: "ID d'embryon",
      semenStrawId: "ID de paille de sperme",
      dataScientist: "Scientifique des données",
      dataScientistReport: "Rapport du scientifique des données",
      productReport: "Rapport de produit",
      dairyProducts: "Les produits laitiers"
    },
    genoPerformance: {
      performanceOfGenoType: "Performances du génotype",
      addAGenoType: "Ajouter un génotype",
      breedName: "Nom de la race",
      chromosome: "Chromosome",
      sequenceChange: "Changement de séquence",
      inheritance: "Héritage",
      diseaseName: "Nom de la maladie",
      referenceSequence: "Séquence de référence",
      pubmedReference: "Référence Pubmed",
      genoTypeRegistration: "Enregistrement du génotype",
      breed: "Race",
      editAGenoType: "Modifier un génotype",
      editGenoType: "Modifier le génotype",
      loadingGene: "Chargement de Geno... Veuillez patienter",
      geneTypeList: "Liste des génotypes"
    },
    reportings: {
      conception: "Conception(Data Scientist)",
      performanceOfGenoData: "Performance du génotype (Data Scientist)",
      totalInsemination: "Insémination totale",
      embryo: "Embryon",
      animalVaccinationRecord: "Carnet de vaccination des animaux",
      dataNotAvailable: "Les données ne sont pas disponibles pour cette ferme.",
      pregnancyStatus: "Statut de grossesse",
      healthReport: "Bilan de santé",
      heavyMilk: "Lait épais",
      standardMilk: "Lait standard"
    },
    sidebar: {
      healthAnalytics: "Analyse de la santé",
      productionAnalytics: "Analyse de production"
    },
    epd: {
      regNo: "Animal Reg No est le code unique donné à l'animal à l'aide d'un moyen de marquage, garantissant un processus effectué pour identifier et suivre des animaux spécifiques",
      internationalID: "ID international de l'animal",
      location: "Pays / Région de naissance de l'animal ",
      animalName: "Nom standard / Nomenclature de l'animal",
      gender: "Sexe de l'animal (mâle/femelle)",
      additionalIDMethod: "Quelle méthode a été utilisée pour identifier l'animal (par exemple, étiquette d'oreille, tatouage)",
      damID: "ID ou numéro d'enregistrement de la mère de l'animal - le parent femelle d'un animal/numéro d'identification de la mère biologique",
      sireId: "Un numéro d'identification ou d'enregistrement du parent mâle d'un animal, en particulier un taureau destiné à la reproduction ou du sperme de taureaux utilisé pour l'insémination artificielle.",
      dateOfBirth: "Date de naissance de l'animal.",
      breederHerdCode: "Code de troupeau d'éleveurs principalement donné par les associations d'éleveurs",
      seasonofBirth: "Saison de naissance de l'animal notée par mois",
      birthYear: "L'année de naissance de l'animal",
      birthManagementCode: "Code de gestion des naissances principalement fourni par l'utilisateur/l'agriculteur",
      birthSex: "Sexe de l'animal (mâle/femelle)",
      birthWeight: "Poids à la naissance du veau ",
      primaryBreed: "Majeur % Contribution génétique de l'animal ",
      secondaryBreed: "Mineure % Contribution génétique de l'animal ",
      breedComposition: "Le pourcentage de composition des races fait référence à la représentation proportionnelle des différentes races dans la constitution génétique d'un animal individuel ou d'un groupe d'animaux. ",
      conceptionMethod: "Comment l'animal a été conçu (accouplement naturel/insémination/transfert d'embryons).",
      accuracyWeight: "Précision Poids",
      damAge: "L'âge du barrage en mois/années, par ex. ",
      weaningWeight: "Sevrage Poids d'un animal au moment du sevrage.",
      weaningDate: "La date à laquelle l'animal a été sevré",
      weaningSex: "Le sexe de l'animal qui a été sevré. ",
      managementPastureCode: "Code donné à la gestion/pâturage par utilisateur/agriculteur ",
      creep: "L'alimentation complémentaire est la pratique consistant à fournir des aliments supplémentaires (grains ou fourrage) aux veaux allaités.",
      weaningContemporaryGroupCode: "Code de Sevrage Poids Groupe Contemporain",
      birthContemporaryCode: "Code contemporain de naissance",
      yearlingDate: "Date de l'animal âgé d'un an ou dans la deuxième année de son âge",
      managementFeedUnitCode: "Code donné à l'unité de gestion/d'alimentation par l'utilisateur",
      yearlingSex: "Le sexe de l'animal au moment du yearling ",
      yearlingWeight: "Le poids d'un an est une mesure de la croissance directe après le sevrage et est souvent utilisé pour refléter la performance potentielle de la progéniture destinée au marché dans le parc d'engraissement, mesurée en livres de veau.",
      yearlingHeight: "Taille de l'animal au moment du yearling ",
      yearlingWeightContemporaryGroupCode: "Code du groupe contemporain de poids d'un an",
      weaningYearlingWeightContemporaryGroupCode: "code du sevrage ou du poids d'un an Groupe contemporain",
      daysOnFeed: "Nombre de jours nourris avec cet aliment particulier Ex : les jeunes bovins en croissance reçoivent un régime riche en énergie pour produire du bœuf commercialisable à un faible coût de gain. ",
      managementFeedUnitPenCode: "Code donné à la gestion/unité d'alimentation/parc par l'utilisateur",
      harvestDate: "Date de l'animal abattu (tué) pour la viande",
      gradingDate: "La date des carcasses a été classée selon un critère particulier",
      carcassSex: "Sexe de la carcasse",
      dateonFeed: "Date à laquelle l'animal est passé à un nouvel aliment Ex : les jeunes bovins en croissance reçoivent une alimentation riche en énergie pour produire du bœuf commercialisable à un faible coût de gain. ",
      KPH: "% KPH est le pourcentage de graisse totale trouvée dans la cavité corporelle d'une carcasse, spécifiquement dans les régions des reins, du bassin et du cœur. ",
      carcassWeight: "Le poids de la carcasse est le poids chaud ou non réfrigéré après la récolte et le retrait de la peau, de la tête, du tractus gastro-intestinal et des organes internes. ",
      fatThickness: "L'épaisseur de graisse est mesurée en pouces à l'aide d'une petite règle. ",
      marbling: "La marbrure est la graisse intramusculaire insaturée (saine) visible qui s'accumule dans le muscle et entre les faisceaux de fibres musculaires.",
      ribeyeArea: "Quantité de surface de faux-filet (longissimus longissimus dorsi) mesurée entre les 12e et 13e côtes en pouces carrés à l'aide d'une grille (par exemple, 8, 9 ou 10 pouces). ",
      animalStatus: "Statut de l'animal dans la ferme, par exemple : à la ferme, vendu, mort, etc."
    },
    manageAnimalGroupings: {
      resetModeTooltip: "\n        MODE RÉINITIALISATION <br>\n            Dans ce mode <br>\n            1) Définir/définir toutes les caractéristiques des groupes contemporains (CG) pour tous les traits d'intérêt. <br>\n            2) Affectez tous les animaux à un CG correspondant. <br>\n            3) Si l'affectation des animaux n'est pas satisfaisante, ajuster/modifier les CG, puis affecter à nouveau les animaux aux nouveaux CG correspondants. <br>\n            4) Répétez les étapes ci-dessus, si nécessaire, jusqu'à ce que vous soyez satisfait des CG et du groupement/affectation correspondant des animaux.<br>\n ",
      maintainanceModeHeadingTooltip: "Une fois le RESET (mode) finalisé, vous entrerez dans le MODE MAINTENANCE où les EDP calculés au RESET seront maintenus constants pour chaque animal jusqu'au prochain RESET (qui pourrait être dans 2 à 6 mois). ",
      maintainanceModeTooltip: "Après avoir terminé le MODE RESET, appuyez sur le bouton RESET FINALIZED pour permettre au système de calculer les EPD de tous les animaux, terminer le MODE RESET et lancer le MODE MAINTENANCE.",
      resetToggleTooltip: "Activez la bascule de réinitialisation dans les paramètres du modèle EPD pour attribuer des animaux aux CG."
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "La génétique",
      geneticSearchTool: "Outil de recherche génétique",
      dataSubmission: "Soumission des données",
      animalsWithExpectedProgenyDifferences: "Animaux avec des différences de descendance attendues (EPD)",
      searchByAnimalIdName: "Recherche par identifiant d'animal, nom",
      rowsPerPage: "Lignes par page",
      individualEntry: "Entrée individuelle",
      bulkEntry: "Entrée en masse",
      registerANewAnimalOrSelectAnExistingAnimal: "Enregistrez un nouvel animal ou sélectionnez un animal existant.",
      registerNewAnimal: "Inscrire un nouvel animal",
      selectExistingAnimal: "Sélectionnez un animal existant",
      animalID: "Identification des animaux",
      animalName: "Nom de l'animal",
      tag: "Étiqueter",
      dateOfBirth: "Date de naissance",
      gender: "Genre",
      birthDate: "Date de naissance",
      birthWeightLb: "Poids à la naissance (lb)",
      birthWeightKg: "Poids à la naissance (kg)",
      weaningWeightLb: "Poids au sevrage (lb)",
      weaningWeightKg: "Poids au sevrage (kg)",
      yearlingWeightLb: "Poids d'un an (lb)",
      yearlingWeightKg: "Poids d'un an (kg)",
      carcassWeightLb: "Poids de la carcasse (lb)",
      carcassWeightKg: "Poids de la carcasse (kg)",
      animalSelection: "Sélection d'animaux",
      animalSearchTool: "Outil de recherche d'animaux",
      back: "Dos",
      searchByEPDs: "Recherche par EPD",
      searchByIds: "Rechercher par ID",
      selectBreed: "Sélectionnez la race",
      selectGender: "Sélectionnez le sexe",
      selectRequiredBreedForCattle: "Sélectionnez la race requise pour les bovins",
      resetFilter: "RÉINITIALISER LE FILTRE",
      birthWeightHeader: "Poids à la naissance (PC) : ",
      birthWeightDef: "Compare les différences de poids des veaux à la naissance et se mesure en livres ou en kg.",
      weaningWeightHeader: "Poids au sevrage (WW): ",
      weaningWeightDef: "WW EPD est une estimation de la croissance avant le sevrage qui est mesurée en livres ou en kg.",
      yearlingWeightHeader: "Poids d'un an (YW): ",
      yearlingWeightDef: "YW EPD est une estimation de la croissance post-sevrage qui est mesurée en livres ou en kg.",
      ribEyeAreaHeader: "Zone Ribeye (REA): ",
      ribEyeAreaDef: "Le REA mesure la taille du muscle qui nous donne le faux-filet en pouces carrés.",
      marblingHeader: "Marbrure(MARB): ",
      marblingDef: "L'EPD MARB est en unités de pourcentage de graisse intramusculaire dans le faux-filet. Les EPD MARB reflètent les différences dans un score de persillage ajusté sur 365 jours (graisse intramusculaire, [IMF]) basé sur les mesures de la carcasse des bovins récoltés.",
      fatThicknessHeader: "Épaisseur de graisse (GRAISSE): ",
      fatThicknessDef: "Pouces de gras dorsal (en centièmes de pouce) est l'unité de mesure pour FT.",
      carcassWeightHeader: "Poids de la carcasse (CW): ",
      carcassWeightDef: "Le poids de la carcasse est un trait bénéfique lorsque l'on considère l'impact que les livres ont par rapport à la valeur du produit final. ",
      yieldGradeHeader: "Niveau de rendement (YG): ",
      yieldGradeDef: "Le système de notation USDA Yield Grade est l'unité de mesure de l'EPD YG. ",
      milkHeader: "Lait (MK): ",
      milkDef: "Le MK EPD est mesuré en livres de poids au sevrage du veau en raison de la capacité de traite de sa mère.",
      totalMaternalHeader: "Total Maternel(MC) : ",
      totalMaternalDef: "La MT mesure l'impact sur le poids au sevrage du veau dû à la fois à la production de lait et à la génétique de la vache pour la croissance.",
      calvingEaseDirectHeader: "Facilité de vêlage Direct (CED): ",
      calvingEaseDirectDef: "L'EPD CED est indiqué en pourcentage de vêlages non assistés.",
      calvingEaseMaternalHeader: "Facilité de Vêlage Maternelle (CEM): ",
      calvingEaseMaternalDef: "Mesure la capacité des filles d'un taureau à vêler sans aide à l'âge de deux ans.",
      stayabilityHeader: "Séjour (SEJOUR): ",
      stayabilityDef: "Le ST EPD prédit la capacité d'un taureau à engendrer des vaches qui « restent ». ",
      docilityHeader: "Docilité (DOC): ",
      docilityDef: "DOC mesure le tempérament du bétail.",
      max: "MAX",
      min: "MIN",
      accuracy: "PRÉCISION",
      sortBy: "Trier par",
      traits: "Les traits affichés en gris sont en cours de développement, à venir au deuxième trimestre 2023.",
      searchResults: "Résultats de recherche",
      recordsFound: "enregistrements trouvés",
      compareSelected: "COMPARER SÉLECTIONNÉ",
      animalIdentification: "Identification des animaux",
      errorMessage: {
        birthWeight: "La valeur maximale du poids à la naissance ne peut pas être inférieure à la valeur minimale du poids à la naissance",
        weaningWeight: "La valeur maximale du poids au sevrage ne peut pas être inférieure à Poids au sevrage minimum",
        yearlingWeight: "La valeur maximale du poids d'un an ne peut pas être inférieure au poids minimal d'un an",
        carcassWeight: "La valeur maximale du poids carcasse ne peut pas être inférieure au poids minimum à la naissance",
        fatThickness: "La valeur maximale de l'épaisseur de graisse ne peut pas être inférieure au poids de sevrage minimum",
        marbling: "La valeur maximale de persillage ne peut pas être inférieure au poids minimum d'un an",
        ribeyeArea: "La valeur maximale de la zone Ribeye ne peut pas être inférieure au poids de naissance minimum",
        yieldGrade: "La valeur maximale de la note de rendement ne peut pas être inférieure au poids au sevrage minimum",
        milk: "La valeur maximale du lait ne peut pas être inférieure au poids de sevrage minimum"
      },
      reg: "Reg",
      name: "Nom",
      sex: "Sexe",
      tattoo: "Tatouage",
      dob: "Date de naissance",
      EPD: "DEP",
      rank: "Rang",
      searchValue: "Valeur de recherche",
      typeHere: "Écrivez ici",
      searching: "Recherche...",
      fetchingResult: "Récupération des résultats... Veuillez patienter",
      animalsMatchedYourCriteria: "Les animaux correspondaient à vos critères",
      manageAnimalsGrouping: "Gérer le groupement d'animaux",
      manageAnimalGroupings: "Gérer les groupes d'animaux",
      assignAnimalToContemporaryGroups: "Attribuer un animal à des groupes contemporains",
      resetMode: "Mode de réinitialisation",
      enterResetMode: "Entrer en mode de réinitialisation",
      maintainanceMode: "Mode d'entretien",
      assigningAnimals: "Attribuer des animaux",
      excludedAnimals: "Animaux exclus",
      ungroupedAnimals: "Animaux non groupés",
      assignAnimalsToCGS: "Attribuer des animaux au CGS",
      reset: "Réinitialiser",
      excludeAnimals: "Exclure les animaux",
      resetToMaintainanceMode: "Réinitialisation finalisée - Passage en mode maintenance",
      contemporaryGroupsSettings: "Paramètres des groupes contemporains (CG)",
      selectTrait: "Sélectionnez le trait",
      selectTraitDescription:"Select Trait fait référence au processus de choix d'un trait spécifique",
      traitsType: {
        birthWeight: "Poids à la naissance",
        weaningWeight: "Poids au sevrage",
        yearlingWeight: "Poids d'un an",
        carcassWeight: "Poids carcasse"
      },
      addNewGroup: "AJOUTER UN NOUVEAU GROUPE",
      contemporaryGroup: "Groupe Contemporain",
      contemporaryGroups: "Groupes contemporains",
      editGroup: "Modifier le groupe",
      birthCGCode: "Code de naissance (CG)",
      groupName: "Nom de groupe",
      birthSex: "Sexe à la naissance",
      conceptionMethod: "Méthode de conception",
      weaningCGCode: "Code de sevrage (CG)",
      yearlingCGCode: "Code Yearling (CG)",
      dateWeight: "Poids des dates",
      weaningyearlingCGcode: "Code de sevrage/1 an (CG)",
      carcassCGCode: "Code de carcasse (CG)",
      breedOfDom: "Race de mère",
      addNewContemporaryGroup: "Ajouter un nouveau groupe contemporain",
      createNewGroup: "Créer un nouveau groupe",
      selectFromDifferentTraits: "Choisissez parmi différents traits",
      contemporaryGroupName: "Nom du groupe contemporain",
      enterNameHere: "Entrez le nom ici",
      groupNameIsRequired: "Le nom du groupe est requis",
      birthYearRange: "Plage d'années de naissance",
      theYearAnimalWasBorn: "L'année de naissance de l'animal",
      birthYearIsRequired: "L'année de naissance est requise",
      genderOfNewBornAnimal: "Sexe de l'animal nouveau-né",
      selectSex: "Sélectionnez le sexe",
      theweightOfAnimalAtBirth: "Le poids de l'animal à la naissance",
      maximumKg: "Maximum",
      minimumKg: "Le minimum",
      aSeasonisAPeriodOfYear: "Une saison est une période de l'année qui se distingue par des conditions climatiques particulières.",
      seasonofBirthIsRequired: "La saison de naissance est requise",
      majorGenericContributionOfAnimal: "Major % contribution générique de l'animal",
      primaryBreedCompostionIsRequired: "La composition de la race primaire est requise",
      secondaryBreedCompostionIsRequired: "La composition de la race secondaire est requise",
      howTheAnimalWasConceived: "Comment l'animal a été conçu (accouplement naturel/insémination/transfert d'embryons)",
      conceptionMethodIsRequired: "La méthode de conception est requise",
      epdModelSettings: "Paramètres du modèle EPD",
      forResetMode: "Pour le mode de réinitialisation",
      progenyWeightingFactor: "Facteur de pondération de la descendance",
      weightGivenToTheProgenyFactor: "Pondération donnée au facteur de descendance par rapport au facteur CG pour le calcul de l'EPD en mode Réinitialisation. ",
      enterNumber: "Entrer un nombre",
      enterBreed: "Entrez la race",
      valueShouldBeBetween0and1: "La valeur doit être comprise entre 0 et 1",
      resetDuration: "Durée de réinitialisation",
      timeIntervalBetweenLastAndFirstResetMode: "Intervalle de temps entre le dernier et le nouveau mode de réinitialisation, à la fin duquel le nouveau mode de réinitialisation est activé et de nouveaux CG et EPD sont calculés.",
      enterNumberOfDays: "Entrez le nombre de jours",
      valueCannotBeNegative: "La valeur ne peut pas être négative !",
      criticalProgenyPopulation: "Population descendante critique",
      minimumNumberOfProgenyRecords: "Nombre minimum d'enregistrements de descendance de l'animal individuel dans le système nécessaire pour atteindre la précision de la descendance (APD1) supérieure à 50 % (pour la précision du pedigree)",
      criticalAncestorPopulation: "Population d'ancêtres critiques",
      minimumNumberOfAncestorsRecords: "Nombre minimum d'enregistrements d'ancêtres de l'animal individuel dans le système nécessaire pour atteindre Ancestor Accuracy (APD4) supérieur à 50 % (pour Pedigree Accuracy)",
      forBirthWeightCG: "Pour le poids de naissance CG",
      criticalPopulationInAnimalsContemporaryGroup: "Population critique dans le groupe contemporain d'animaux",
      minimumAverageNumberOfAnimalsPerBirthWeight: "Nombre moyen minimum d'animaux par CG de poids à la naissance nécessaire pour atteindre une précision CG moyenne (ACG3) supérieure à 50 %",
      criticalAveragePopulationPerContemporaryGroup: "Population moyenne critique par groupe contemporain",
      minimumNumberOfAnimalsInBirthWeight: "Nombre minimum d'animaux dans le CG du poids à la naissance de l'animal nécessaire pour atteindre une précision CG (ACG2) supérieure à 50 %",
      forWeaningWeightCG: "Pour le poids au sevrage CG",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "Nombre moyen minimum d'animaux par poids au sevrage CG nécessaire pour atteindre une précision CG moyenne (ACG3) supérieure à 50 %",
      minimumNumberOfAnimalsInWeaningWeight: "Nombre minimum d'animaux dans le CG du poids au sevrage de l'animal nécessaire pour atteindre une précision CG (ACG2) supérieure à 50 %",
      forYearlingWeightCG: "Pour le CG de poids d'un an",
      minimumAverageNumberOfAnimalsPerYearling: "Nombre moyen minimum d'animaux par CG d'un an nécessaire pour atteindre une précision CG moyenne (ACG3) supérieure à 50 %",
      minimumNumberOfAnimalsInYearlingWeight: "Nombre minimum d'animaux dans le CG de poids Yearling de l'animal nécessaire pour atteindre une précision CG (ACG2) supérieure à 50 %",
      forCarcassCG: "Pour Carcasse CG",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "Nombre moyen minimum d'animaux par CG de poids de carcasse nécessaire pour atteindre une précision CG moyenne (ACG3) supérieure à 50 %",
      minimumNumberOFAnimalInCarcassWeight: "Nombre minimum d'animaux dans le CG du poids carcasse de l'animal nécessaire pour atteindre une précision CG (ACG2) supérieure à 50 %",
      epdRequiredFieldSettings: "Paramètres des champs obligatoires EPD",
      pleaseSelectRequiredFieldsForCompleteEPD: "Veuillez sélectionner les champs obligatoires pour un calcul EPD complet",
      byDefault: "Par défaut",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "Remarque : Veuillez noter que les utilisateurs ne pourront pas obtenir le calcul complet de l'EPD s'ils ne fournissent pas les champs de données que vous marquez comme obligatoires.",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "Remarque : Veuillez noter que les paramètres de champ obligatoires ne peuvent pas être modifiés car il existe déjà des groupes contemporains par rapport aux paramètres précédents.",
      noResultFound: "AUCUN RÉSULTAT TROUVÉ",
      next: "Suivant",
      cancel: "Annuler",
      selectAnimal: "Sélectionnez un animal",
      searchBy: "Recherché par",
      breed: "Race",
      regDate: "Rég. ",
      status: "Statut",
      animalDetails: "Détails des animaux",
      add: "Ajouter",
      update: "Mise à jour",
      dataForEPDs: " Données pour les EPD",
      basicInformation: "Informations de base",
      birthWeightInformation: "Informations sur le poids à la naissance",
      weaningWeightInformation: "Informations sur le poids au sevrage",
      yearlingWeightInformation: "Informations sur le poids des yearlings",
      carcassWeightInformation: "Informations sur le poids de la carcasse",
      delete: "Supprimer",
      deleteEpdData: "Supprimer les données EPD",
      areYouSureYouWantToDeleteEpdData: "Êtes-vous sûr de vouloir supprimer les données EPD.",
      internationalID: "Carte d'identité internationale",
      enterID: "Entrez l'identifiant",
      animalRegistration: "Enregistrement des animaux",
      location: "Emplacement",
      additionalIDMethod: "Méthode d'identification supplémentaire",
      damID: "ID du barrage",
      sireID: "ID du père",
      breederHerdCode: "Code du troupeau de l'éleveur",
      birthYear: "Année de naissance",
      primaryBreed: "Race primaire",
      breedComposition: "Composition de la race",
      secondaryBreed: "Race secondaire",
      seasonofBirth: "Saison de naissance",
      birthManagementCode: "Code de gestion des naissances",
      damAge: "Dommage",
      years: "Années",
      birthContemporaryCode: "Code contemporain de naissance",
      accuracyWeight: "Précision Poids",
      note: "Note",
      minimumRequiredFieldForBirthWeight: "Champ minimum requis pour les EPD de poids à la naissance",
      birthYearGenderConceptionMethodBirthWeight: "Année de naissance , Sexe , Méthode de conception , Poids à la naissance",
      weaningWeight: "Poids au sevrage",
      weaningDate: "Date de sevrage",
      weaningContemporaryGroupCode: "Code de groupe contemporain de sevrage",
      creep: "Fluer",
      managementPastureCode: "Code de gestion/pâturage",
      weaningSex: "Sexe de sevrage",
      minimumRequiredFieldForWeaningWeight: "Champ minimum requis pour les EPD du poids au sevrage",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "Poids au sevrage , Code de régie/pâturage , Sexe au sevrage , Date de pesée",
      yearlingWeight: "Poids d'un an",
      yearlingHeight: "Hauteur d'un an",
      yearlingDate: "Date de 1 an",
      yearlingContemporaryGroupCode: "Code de groupe contemporain d'un an",
      managementFeedingCode: "Code de gestion/alimentation",
      yearlingSex: "Sexe d'un an",
      youWillNeedToFillOutFor: "Vous devrez remplir tous les champs pour récupérer les données EPD pour",
      pleaseSelectHavestDateFirstToEnterInfo: "Veuillez d'abord sélectionner \"Date de récolte\" pour saisir les informations relatives à la zone des faux-filets, à l'épaisseur de la graisse et au persillage",
      harvestDate: "Date de récolte",
      dateOnFeed: "Date du flux",
      daysOnFeed: "Jours d'alimentation",
      gradingDate: "Date de classement",
      carcassSex: "Sexe de carcasse",
      carcassWeight: "Poids carcasse",
      carcassContemporary: "Carcasse Contemporain",
      damBreed: "Race maternelle",
      ribEyeArea: "Zone de faux-filet",
      ribEyeAreaContemporary: "Faux-filet Contemporain",
      fatThickness: "Épaisseur de graisse",
      fatThicknessContemporary: "Épaisseur de gras Contemporain",
      marbling: "Marbrure",
      marblingContemporary: "Marbrure Contemporain",
      yieldGradeContemporary: "Rendement Grade Contemporain",
      animalsNotListedInContemporaryGroupsMsg: "Les animaux n'ont été ajoutés à aucun groupe contemporain en raison d'informations manquantes. ",
      listOfUngroupedAnimals: "Liste des animaux non groupés",
      submittingData: "Soumission des données",
      resendToUser: "Renvoyer à l'utilisateur",
      submittingAnimalsInGroupMsg: "Soumettre vos animaux en groupes. ",
      pressingResetBtnMsg: "Appuyer sur le bouton \"Réinitialiser\" lancera un processus pour réaffecter les animaux à leurs groupes contemporains.",
      doYouWantToProceed: "Voulez-vous poursuivre ?",
      systemMaintainanceModeMsg: "Appuyer sur le bouton \"Changer en mode maintenance\" lancera un processus et votre système entrera en \"MODE MAINTENANCE\" où les EDP calculés lors de la RÉINITIALISATION seront maintenus constants pour chaque animal jusqu'à la prochaine RÉINITIALISATION (qui pourrait être de 1 à 6 mois ",
      errorFetchingContemporaryGrpMsg: "Erreur lors de la récupération des données du groupe contemporain",
      deleteSuccess: "Supprimer le succès",
      deleteSuccessMsg: "Groupe contemporain supprimé avec succès.",
      deleteFailed: "Échec de la suppression",
      deleteFailedMsg: "Erreur lors de la suppression des données du groupe contemporain",
      deleteContemporaryGrpMsg: "Voulez-vous vraiment supprimer ce groupe contemporain ?",
      addBirthWeightData: "Ajouter des données sur le poids à la naissance",
      addWeaningWeightData: "Ajouter des données sur le poids au sevrage",
      birthWeightContemporaryGroupCode: "Code de groupe contemporain du poids à la naissance",
      dateWeighted: "Date pondérée",
      addYearlingWeightData: "Ajouter des données de poids d'un an",
      addCarcassWeightData: "Ajouter des données sur le poids de la carcasse",
      weaningOrYearlingContemporaryGroupCode: "Code de groupe contemporain du poids au sevrage ou à l'âge d'un an",
      deleteContemporaryGroupMsg: "Voulez-vous vraiment supprimer le groupe contemporain ?",
      updateSuccessMsg: "Groupe contemporain mis à jour avec succès.",
      errorMsg: "Quelque chose s'est mal passé. ",
      fetchErrorMsg: "Erreur lors de la récupération des champs obligatoires pour le trait sélectionné.",
      forMaintainanceMode: "Pour le mode maintenance",
      ancestorsWeightFactor: "Facteur de poids des ancêtres",
      weightGivenToTheAncestorFactor: "Pondération donnée au facteur ancêtre par rapport au facteur CG pour le calcul de l'EPD en mode Maintenance. ",
      addEPDModelSettingsData: "Ajouter des données de paramètres de modèle EPD",
      minimumNumberOfAnimalsInContemporaryGroups: "Nombre minimum d'animaux dans les groupes contemporains",
      enterNumberOfAnimals: "Entrez le nombre d'animaux",
      areYouSureYouWantToChangeEPDCalculation: "Voulez-vous vraiment modifier les champs de calcul EPD requis ?",
      weightOfAnimalAtBirth: "Poids de l'animal à la naissance",
      seasonIsAPeriodOfYear: "Une saison est une période de l'année qui se distingue par des conditions climatiques particulières.",
      codeOfBirthWeightContemporaryGroup: "Code du groupe contemporain de poids à la naissance",
      weaningWeightOfCalf: "Poids au sevrage du veau",
      dateAnimalWasWeaned: "La date à laquelle l'animal a été sevré",
      genderOfWeaningAnimal: "Sexe de l'animal sevré",
      yearlingWeightOfCalf: "Poids d'un veau d'un an",
      dateAnimalWasWeighted: "La date à laquelle l'animal a été pesé",
      yearledAnimalSex: "Le sexe de l'animal qui a été élevé",
      dateOfAnimalKilledForMeat: "Date de l'animal tué pour la viande",
      addSuccessMsg: "Groupe contemporain ajouté avec succès",
      traitH: "Le trait pour le calcul EPD.",
      searchByValue: "Entrez le numéro d'enregistrement/le tatouage/le nom/le tag"
    }
  }